import React, { useCallback, useEffect, useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import ReactTimeago from "react-timeago";
import { SECTIONS } from "../Game/PlayerSection/PlayerSection";

export function shuffleArray(array) {
    for (var i = array.length - 1; i >= 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = array[i];
        array[i] = array[j];
        array[j] = temp;
    }
}

export function FeedbackButton({ duration = 1000, ...props}) {
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        if (isLoading) {
            setTimeout(() => {
                setLoading(false)
            }, duration)
        }
    }, [isLoading]);

    const handleClick = () => setLoading(true);

    return (
        <Button
            variant={props.variant}
            disabled={isLoading || props.disabled}
            className={props.className}
            onClick={() => {
                if (!isLoading) {
                    handleClick()
                    props.onClick()
                }
            }}
        >
            {isLoading ? props.feedBack : props.children}
        </Button>
    );
}

export function CustomTimeAgo({ date }) {
    const now = new Date();
    const diffInSeconds = Math.floor((now - new Date(date)) / 1000);

    if (diffInSeconds < 60) {
        return <span>recently</span>;
    }

    return <ReactTimeago date={date} />;
}

export function swapHideOrRevealCard(card, playerId, opponentIds, defaultRevealedState) {
    let isCardCurrentlyHidden = isCardHidden(card, playerId, opponentIds)
    if (isCardCurrentlyHidden === "yes") {
        hideCard(card, defaultRevealedState, playerId, opponentIds)
    } else {
        hideCard(card, "yes", playerId, opponentIds)
    }
}

export function hideCard(card, val, playerId, opponentIds) {
    card.hiddenTo = {}
    if (val == "yes") {
        [...opponentIds, playerId].forEach(id => {
            card.hiddenTo[id] = true
        })
    } else if (val == "opponent-only") {
        opponentIds.forEach(id => {
            card.hiddenTo[id] = true
        })
    }
}

export function isCardHidden(card, playerId, opponentIds) {
    let isHidden = "opponent-only"
    if (card.hiddenTo[playerId]) {
        isHidden = "yes"
    }
    opponentIds.forEach(id => {
        if (!card.hiddenTo[id]) {
            isHidden = "no"
        }
    })
    return isHidden
}

export function BlurredBackground() {
    return (<div className="position-absolute blurred-background w-100 h-100 start-0 top-0">
        <div className="blur position-absolute top-0 start-0 h-100 w-100"></div>
        <div className="background position-absolute top-0 start-0 h-100 w-100"></div>
    </div>)
}
/*
export function IMG({ src, ...props }) {
    const [loaded, setLoaded] = useState(false);
    const [imgSrc, setImgSrc] = useState(null);

    const handleError = (e) => {
        e.target.onerror = null; // Prevent looping in case fallback fails
        e.target.src = require('../Home/Assets/homepage_card_1.jpg');
        setLoaded("error")
    };

    useEffect(() => {
        setImgSrc(src);
    }, [src]);

    useEffect(() => {
        setLoaded(false)
    }, [])

    return (
        <span>
            <img
                src={require('./Assets/Images/card-placeholder.jpg')}
                {...props}
                width="70" height="100"
            />
            <div className="w-100 h-100 d-flex justify-content-center align-items-center card-placeholder-spinner position-absolute top-0 start-0" style={{ visibility: loaded === false ? "visible" : "hidden" }}>
                <Spinner animation="border" role="status" />
            </div>
            <div className="w-100 h-100 d-flex justify-content-center align-items-center card-placeholder-spinner position-absolute top-0 start-0" style={{ visibility: loaded === "error" ? "visible" : "hidden" }}>
                <h5>Error</h5>
            </div>
            <div className="w-100 h-100" style={{ opacity: loaded === true ? 1 : 0.00001, position: "absolute", top: 0, left: 0 }}>
                <img
                    src={imgSrc}
                    width="70" height="100"
                    onLoad={() => setLoaded(true)}
                    {...props}
                    onError={handleError}
                    referrerPolicy="no-referrer"
                    referrerpolicy="no-referrer"
                />
            </div>
        </span>
    );
}*/

const fallbackSrc = require('./Assets/Images/card-placeholder.jpg');
const placeholderSrc = require('./Assets/Images/card-placeholder.jpg');

export const IMG = React.memo(function IMG({ src, ...props }) {
    const [loaded, setLoaded] = useState(false);
    const [imgSrc, setImgSrc] = useState(null);

    useEffect(() => {
        if (imgSrc !== src) {
            setImgSrc(src);
            setLoaded(false); // reset loading state on new src
        }
    }, [src]);

    const handleError = useCallback((e) => {
        e.target.onerror = null;
        e.target.src = fallbackSrc;
        setImgSrc(fallbackSrc)
        setLoaded("error");
    }, []);

    if (loaded === true) {
        return (<img
            src={imgSrc}
            key={imgSrc}
            width="70"
            height="100"
            onError={handleError}
            referrerPolicy="no-referrer"
            {...props}
            alt=""
        />)
    }

    return (
        <span>
            {/* Placeholder Image */}
            <span className="placeholder-image">
                <img
                    src={placeholderSrc}
                    width="70"
                    height="100"
                    {...props}
                    alt=""
                    style={{ ...props.style, boxShadow: 'none' }}
                />
            </span>

            {/* Spinner Overlay */}
            <div
                className="w-100 h-100 d-flex justify-content-center align-items-center card-placeholder-spinner position-absolute top-0 start-0"
                style={{ visibility: loaded === false ? "visible" : "hidden" }}
            >
                <Spinner animation="border" role="status" />
            </div>

            {/* Loaded Image (a revoir opacity) */}
            <div
                className="w-100 h-100"
                style={{
                    opacity: loaded === true ? 1 : 0,
                    position: "absolute",
                    top: 0,
                    left: 0,
                    transition: "opacity 0.2s ease"
                }}
            >
                <img
                    src={imgSrc}
                    key={imgSrc}
                    width="70"
                    height="100"
                    onLoad={() => setLoaded(true)}
                    onError={handleError}
                    referrerPolicy="no-referrer"
                    {...props}
                    alt=""
                />
            </div>

            {/* Error Message Overlay */}
            <div
                className="w-100 h-100 d-flex justify-content-center align-items-center card-placeholder-spinner position-absolute top-0 start-0"
                style={{ visibility: loaded === "error" ? "visible" : "hidden" }}
            >
                <h5>Error</h5>
            </div>
        </span>
    );
});

// Card positioning helper
export function setPositions(array, sectionRect, alignment, cardSizeVh) {
    if (!sectionRect) return;

    let rect = sectionRect;
    array.forEach((data, i) => {
        if (data.card.position.index === undefined) {
            data.card.position.index = 99999;
        }
    });

    let totalWidth = 0;
    array.forEach((c) => {
        const { card } = c;
        const { cardSize } = card.position;
        totalWidth += card.isHorizontal && card.isTapped
            ? cardSize.height
            : cardSize.width;

        if (card.grouppedCards) {
            totalWidth += card.grouppedCards.length * (cardSize.width / 2);
        }
    });

    totalWidth *= cardSizeVh;

    let alignmentOffset = 0;
    if (alignment === SECTIONS.ALIGNMENTS.CENTER) {
        alignmentOffset = rect.width / 2 - Math.min(totalWidth, rect.width) / 2;
    } else if (alignment === SECTIONS.ALIGNMENTS.END) {
        alignmentOffset = rect.width;
    }

    let shrinkOffset = 0;
    if (totalWidth > rect.width) {
        const tooMuch = totalWidth - rect.width;
        shrinkOffset = tooMuch / (array.length - 1);
    }

    array.sort((a, b) => a.card.position.index - b.card.position.index);
    let cumulatedWidth = 0;

    array.forEach((data, i) => {
        const card = data.card;
        if (card.grouppedToId) { return }
        const groupSpacing = (card.position.cardSize.width / 2) * cardSizeVh;

        let childWidth = 0;
        if (card.grouppedCards) {
            childWidth = groupSpacing * card.grouppedCards.length;
        }

        card.position.index = i;
        card.position.reversedIndex = array.length - i - 1;

        if (card.position.section === SECTIONS.STACK) {
            card.position.reversedIndex = array.length - card.stackIndex;
            card.position.index = 100 + card.stackIndex;
        }

        const baseLeft = rect.left + cumulatedWidth + alignmentOffset - (i > 0 ? shrinkOffset * i : 0) + childWidth;
        const baseTop = rect.top;

        if (alignment === SECTIONS.ALIGNMENTS.NONE) {
            card.position.pos = { left: rect.left, top: baseTop };
        } else if (alignment === SECTIONS.ALIGNMENTS.END) {
            card.position.pos = {
                left: rect.left + alignmentOffset - cumulatedWidth + (i > 0 ? shrinkOffset * i : 0) - childWidth - card.position.cardSize.width * cardSizeVh,
                top: baseTop
            };
        } else {
            card.position.pos = { left: baseLeft, top: baseTop };
        }

        // Groupped cards
        if (card.grouppedCards) {
            const basePos = { ...card.position.pos };
            card.grouppedCards.forEach((c, j) => {
                c.position.pos = {
                    left: alignment === SECTIONS.ALIGNMENTS.END
                        ? basePos.left + groupSpacing * (j + 1)
                        : basePos.left - groupSpacing * (j + 1),
                    top: basePos.top + card.position.cardSize.height * cardSizeVh * 0.1
                };
                c.position.index = i - 10 - j;
            });
        }

        const cWidth = (card.isHorizontal && card.isTapped
            ? card.position.cardSize.height
            : card.position.cardSize.width) * cardSizeVh + childWidth;

        cumulatedWidth += cWidth;
    });
}

export const displayOrderDebug = [
    "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
    "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
    "fed75268-c816-48fd-8eb4-d5a87396332e"
]

export const opponentDataDebug = {
    "faa9bafc-3ce4-49e1-b19c-72054e5ff63b": {
        "visibleCards": [
            {
                "id": "19e80480-47c9-41ae-8803-c7191c18303d",
                "position": {
                    "section": "Mana",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 4,
                    "reversedIndex": 1,
                    "pos": {
                        "left": 409.87537499999996,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": true,
                "isFlipped": false,
                "cardData": {
                    "id": "6587a463-a108-4854-b6d1-944e89b8c8a4",
                    "name": "Wooded Foothills",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Wooded Foothills",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/4/e/4e11ea8a-f895-438d-a3b7-f070238e4161.jpg?1717013111"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "mh3",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "09082b91-e3aa-46c2-84f4-d4113f915a44",
                "position": {
                    "section": "Creatures",
                    "cardSize": {
                        "width": 14,
                        "height": 20
                    },
                    "index": 3,
                    "reversedIndex": 1,
                    "pos": {
                        "left": 977.001875,
                        "top": 4.59375
                    }
                },
                "hiddenTo": {},
                "isTapped": null,
                "isFlipped": false,
                "cardData": {
                    "id": "e3b9c9e3-5a35-4dd2-ab17-d1b6a140b185",
                    "name": "Riddlesmith",
                    "type": "Creature",
                    "Card type": "Creature — Human Artificer",
                    "face": {
                        "front": {
                            "name": "Riddlesmith",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/6/4/640ff8a9-9dff-4fc7-bafa-6afaa3d9c153.jpg?1651655745"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "nec",
                    "isHorizontal": false,
                    "power": 2,
                    "toughness": 1,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "96331ac2-5c75-4d22-8e05-c9dfa979b5a0",
                "position": {
                    "section": "Other",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 5,
                    "reversedIndex": 5,
                    "pos": {
                        "left": 1188.4276875,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": null,
                "isFlipped": false,
                "cardData": {
                    "id": "4b033a0a-c1ae-44d7-9662-72cbbfda024b",
                    "name": "Aether Spellbomb",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Aether Spellbomb",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/a/5/a54e8ce9-edd7-4ae7-9521-6fb6727cf63b.jpg?1601080529"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "U"
                    ],
                    "set": "jmp",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "b9acd654-a77d-48fd-9671-6e1710bf000e",
                "position": {
                    "section": "Creatures",
                    "cardSize": {
                        "width": 14,
                        "height": 20
                    },
                    "index": 2,
                    "reversedIndex": 2,
                    "pos": {
                        "left": 848.3418750000001,
                        "top": 4.59375
                    }
                },
                "hiddenTo": {},
                "isTapped": null,
                "isFlipped": false,
                "cardData": {
                    "id": "e0aa6ce0-ca31-433b-ac6c-32b8675cdb71",
                    "name": "Spellskite",
                    "type": "Creature",
                    "Card type": "Artifact Creature — Phyrexian Horror",
                    "face": {
                        "front": {
                            "name": "Spellskite",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/7/2/72204934-f5aa-4559-8f7e-7b0b223580d0.jpg?1674142724"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "U"
                    ],
                    "set": "clb",
                    "isHorizontal": false,
                    "power": 0,
                    "toughness": 4,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "f6d1011f-a5a8-45ef-9dae-3cd09388d242",
                "position": {
                    "section": "Creatures",
                    "cardSize": {
                        "width": 14,
                        "height": 20
                    },
                    "index": 1,
                    "reversedIndex": 3,
                    "pos": {
                        "left": 719.681875,
                        "top": 4.59375
                    }
                },
                "hiddenTo": {},
                "isTapped": null,
                "isFlipped": false,
                "cardData": {
                    "id": "c9722086-23e8-43dc-8a8c-541ff6962318",
                    "name": "Enthusiastic Mechanaut",
                    "type": "Creature",
                    "Card type": "Artifact Creature — Goblin Artificer",
                    "face": {
                        "front": {
                            "name": "Enthusiastic Mechanaut",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/a/c/ac00521f-1b7d-478d-afe8-6761ea512d8d.jpg?1654568430"
                        }
                    },
                    "Colors": [
                        "R",
                        "U"
                    ],
                    "Color identity": [
                        "R",
                        "U"
                    ],
                    "set": "neo",
                    "isHorizontal": false,
                    "power": 2,
                    "toughness": 2,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "d82bafca-42de-4929-adb8-34e962b3979c",
                "position": {
                    "section": "Creatures",
                    "cardSize": {
                        "width": 14,
                        "height": 20
                    },
                    "index": 0,
                    "reversedIndex": 4,
                    "pos": {
                        "left": 591.021875,
                        "top": 4.59375
                    }
                },
                "hiddenTo": {},
                "isTapped": null,
                "isFlipped": false,
                "cardData": {
                    "id": "09ef446c-a13d-49d9-a94c-cd5f5a2d440b",
                    "name": "Displacer Kitten",
                    "type": "Creature",
                    "Card type": "Creature — Cat Beast",
                    "face": {
                        "front": {
                            "name": "Displacer Kitten",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/c/7/c7a401b8-29fb-46ef-a663-427f66724d5c.jpg?1674135465"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "clb",
                    "isHorizontal": false,
                    "power": 2,
                    "toughness": 2,
                    "cost": 4
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "04aae6f3-62cc-44da-b5b9-ba40ae09ba08",
                "position": {
                    "section": "Mana",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 1,
                    "reversedIndex": 4,
                    "pos": {
                        "left": 158.988375,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": true,
                "isFlipped": false,
                "cardData": {
                    "id": "cb027150-848c-4a66-88ad-e20222304dd8",
                    "name": "Scalding Tarn",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Scalding Tarn",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/7/1/71e491c5-8c07-449b-b2f1-ffa052e6d311.jpg?1738703652"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "mh2",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "28654848-720b-4a38-bce2-25d75c0cdd52",
                "position": {
                    "section": "Commander",
                    "pos": {
                        "left": 75.359375,
                        "top": 4.59375
                    },
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 0,
                    "reversedIndex": 0
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "c803b788-4213-4fab-b841-7e5bbf66088e",
                    "name": "Jhoira, Weatherlight Captain",
                    "type": "Creature",
                    "Card type": "Legendary Creature — Human Artificer",
                    "face": {
                        "front": {
                            "name": "Jhoira, Weatherlight Captain",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/4/f/4f77d23d-6257-4dae-b585-29f45f13f2e2.jpg?1599708079"
                        }
                    },
                    "Colors": [
                        "R",
                        "U"
                    ],
                    "Color identity": [
                        "R",
                        "U"
                    ],
                    "set": "2xm",
                    "isHorizontal": false,
                    "power": 3,
                    "toughness": 3,
                    "cost": 4
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "55e37604-2391-412d-9a03-256470842249",
                "position": {
                    "section": "Discard",
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 6,
                    "reversedIndex": 1,
                    "pos": {
                        "left": 1364.03125,
                        "top": 360.703125
                    }
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "2cce7250-f8f9-4c0a-87b1-ba3c5b8ed6b3",
                    "name": "Paradoxical Outcome",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Paradoxical Outcome",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/1/7/17e50157-bf49-4c5f-9b8a-bf73484e63a5.jpg?1576381375"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "kld",
                    "isHorizontal": false,
                    "cost": 4
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "32ab6065-6be7-4310-a2da-6a5984ead866",
                "position": {
                    "section": "Other",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 2,
                    "reversedIndex": 8,
                    "pos": {
                        "left": 1392.47805,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": null,
                "isFlipped": false,
                "cardData": {
                    "id": "b1f8eb7b-7e01-4bf8-a557-64e16a6052af",
                    "name": "Crystal Skull, Isu Spyglass",
                    "type": "Artifact",
                    "Card type": "Legendary Artifact",
                    "face": {
                        "front": {
                            "name": "Crystal Skull, Isu Spyglass",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/b/1/b10fa72b-6742-4b65-8654-ac70b6240e38.jpg?1721423673"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "acr",
                    "isHorizontal": false,
                    "cost": 4
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "c7f442ca-2ad1-4855-be4f-15943d32240c",
                "position": {
                    "section": "Discard",
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 4,
                    "reversedIndex": 3,
                    "pos": {
                        "left": 1364.03125,
                        "top": 360.703125
                    }
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "74d3277a-38e5-4732-afed-084a56148f20",
                    "name": "Mana Drain",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Mana Drain",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/3/c/3c429c40-2389-41e5-8681-4bb274e25eba.jpg?1737917379"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "2x2",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "1d6ef508-08d9-4fb8-a8bf-291637d2bf08",
                "position": {
                    "section": "Other",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 1,
                    "reversedIndex": 9,
                    "pos": {
                        "left": 1460.4948375,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": null,
                "isFlipped": false,
                "cardData": {
                    "id": "23216e59-f147-4bb7-a698-12777c2f8584",
                    "name": "Jeweled Lotus",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Jeweled Lotus",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/d/7/d7183700-6941-4a3d-a581-4f33bea795e9.jpg?1727093687"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "cmm",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "fbf0448e-444c-4c82-ae5d-53a445d8048f",
                "position": {
                    "section": "Mana",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 0,
                    "reversedIndex": 5,
                    "pos": {
                        "left": 75.359375,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": true,
                "isFlipped": false,
                "cardData": {
                    "id": "e9b6a394-691c-425a-9307-76d8edc7375e",
                    "name": "Otawara, Soaring City",
                    "type": "Land",
                    "Card type": "Legendary Land",
                    "face": {
                        "front": {
                            "name": "Otawara, Soaring City",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/4/8/486d7edc-d983-41f0-8b78-c99aecd72996.jpg?1654568960"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "U"
                    ],
                    "set": "neo",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "2efc2d33-c628-4ff2-a63c-4dcf06944ff0",
                "position": {
                    "section": "Discard",
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 7,
                    "reversedIndex": 0,
                    "pos": {
                        "left": 1364.03125,
                        "top": 360.703125
                    }
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "f3e213a4-ba5a-468a-93b3-c0a34e1bd725",
                    "name": "Pact of Negation",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Pact of Negation",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/1/e/1ed4c0bb-b710-44a1-b8bc-6bd11c27b8b8.jpg?1697121218"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "tsr",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "ad7954a9-6574-4a85-8a95-da6d1dd47979",
                "position": {
                    "section": "Other",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 0,
                    "reversedIndex": 10,
                    "pos": {
                        "left": 1528.511625,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": null,
                "isFlipped": false,
                "cardData": {
                    "id": "4fd493b3-63f9-4633-8f88-8755e489da32",
                    "name": "Conjurer's Bauble",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Conjurer's Bauble",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/2/d/2d32960e-d182-455f-8e74-eb11b10050da.jpg?1562876061"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "5dn",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "9e6e392b-7bc8-4d42-b2ef-8325011f8ec1",
                "position": {
                    "section": "Discard",
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 5,
                    "reversedIndex": 2,
                    "pos": {
                        "left": 1364.03125,
                        "top": 360.703125
                    }
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "d75b9c82-1b49-4c3e-a1b5-aeef57d6644b",
                    "name": "Cyclonic Rift",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Cyclonic Rift",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/d/f/dfb7c4b9-f2f4-4d4e-baf2-86551c8150fe.jpg?1702429366"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "rvr",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "f552d756-e156-436d-871e-b0806de9f0ff",
                "position": {
                    "section": "Mana",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 2,
                    "reversedIndex": 3,
                    "pos": {
                        "left": 242.61737499999998,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": true,
                "isFlipped": false,
                "cardData": {
                    "id": "c0adbddc-b070-4c5f-afe0-0474c72a9251",
                    "name": "Gemstone Caverns",
                    "type": "Land",
                    "Card type": "Legendary Land",
                    "face": {
                        "front": {
                            "name": "Gemstone Caverns",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/7/f/7f273641-c5f3-48bc-b89e-3cff52d26a0b.jpg?1619399338"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "tsr",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "94e2560b-0388-4112-bf71-b1c61c30f820",
                "position": {
                    "section": "Other",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 3,
                    "reversedIndex": 7,
                    "pos": {
                        "left": 1324.4612625,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": null,
                "isFlipped": false,
                "cardData": {
                    "id": "523d3e3d-8fdf-44f8-868d-7b00995e4577",
                    "name": "Words of Wind",
                    "type": "Enchantment",
                    "Card type": "Enchantment",
                    "face": {
                        "front": {
                            "name": "Words of Wind",
                            "type": "Enchantment",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/5/5/5595a57a-a76c-467b-afaf-5affffc24f35.jpg?1562915041"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "ons",
                    "isHorizontal": false,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "360d4302-6df9-4c47-8691-52c7554ba620",
                "position": {
                    "section": "Mana",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 3,
                    "reversedIndex": 2,
                    "pos": {
                        "left": 326.24637499999994,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": true,
                "isFlipped": false,
                "cardData": {
                    "id": "a3fb7228-e76b-4e96-a40e-20b5fed75685",
                    "name": "Mountain",
                    "type": "Land",
                    "Card type": "Basic Land — Mountain",
                    "face": {
                        "front": {
                            "name": "Mountain",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/b/f/bfa10a88-12e0-4b79-80bb-6f4620277e20.jpg?1743205117"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "R"
                    ],
                    "set": "tdm",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "1ffd8d79-8804-48eb-8b11-fa005e7e8147",
                "position": {
                    "section": "Other",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 4,
                    "reversedIndex": 6,
                    "pos": {
                        "left": 1256.4444749999998,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": null,
                "isFlipped": false,
                "cardData": {
                    "id": "0a79237e-0811-4a8a-bd4d-db3ca91bff22",
                    "name": "Everflowing Chalice",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Everflowing Chalice",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/e/8/e89eca1c-19f5-4db0-9330-cecb87be8b55.jpg?1706241052"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "mkc",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "81db58e6-fb2e-4183-b41f-b08e0d49fddb",
                "position": {
                    "section": "Discard",
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 3,
                    "reversedIndex": 4,
                    "pos": {
                        "left": 1364.03125,
                        "top": 360.703125
                    }
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "2167ac25-d042-4b48-b770-8b94acc1a965",
                    "name": "Chain of Vapor",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Chain of Vapor",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/3/8/38f741bf-13ee-4384-98ab-27833ebb9f6d.jpg?1562395835"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "c16",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "53908c6a-5cc0-47e2-85a4-5e9dbfa0c928",
                "position": {
                    "section": "Discard",
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 2,
                    "reversedIndex": 5,
                    "pos": {
                        "left": 1364.03125,
                        "top": 360.703125
                    }
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "d09c9cba-fdd2-479b-ad5d-d05181c3e3f9",
                    "name": "Fierce Guardianship",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Fierce Guardianship",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/f/7/f7f3dd95-bd14-4e0f-a388-444f9cf1b0dc.jpg?1689996370"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "cmm",
                    "isHorizontal": false,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "3e8c6709-599b-4e25-8116-1051f574ddee",
                "position": {
                    "section": "Other",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 6,
                    "reversedIndex": 4,
                    "pos": {
                        "left": 1120.4108999999999,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": null,
                "isFlipped": false,
                "cardData": {
                    "id": "17dbbca3-ac1c-4d4e-9618-3e66ac3ccd24",
                    "name": "Urza's Bauble",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Urza's Bauble",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/2/9/29175e6b-a2ab-4373-8093-cb372aa8c7d0.jpg?1559592523"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "me1",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "0795861d-f52e-4015-84d4-192f0a2bcf38",
                "position": {
                    "section": "Other",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 9,
                    "reversedIndex": 1,
                    "pos": {
                        "left": 916.3605374999997,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": null,
                "isFlipped": false,
                "cardData": {
                    "id": "1b5e6560-ff2e-4475-96cb-63f64c8a86db",
                    "name": "Soul-Guide Lantern",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Soul-Guide Lantern",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/6/d/6d3ff537-86f0-405e-b96b-1250720af031.jpg?1730491171"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "fdn",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "b0382b7a-4a1f-4ebc-911d-f01745b26cb7",
                "position": {
                    "section": "Other",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 7,
                    "reversedIndex": 3,
                    "pos": {
                        "left": 1052.3941125,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": null,
                "isFlipped": false,
                "cardData": {
                    "id": "8a52f3c0-2552-4425-b2e3-5496eb2232a7",
                    "name": "Mystic Remora",
                    "type": "Enchantment",
                    "Card type": "Enchantment",
                    "face": {
                        "front": {
                            "name": "Mystic Remora",
                            "type": "Enchantment",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/4/0/40140991-cffa-4b52-9a25-37e9a8aa9ddd.jpg?1675199366"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "dmr",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "28fcdd1b-d1fd-498a-b19a-00ab2efab799",
                "position": {
                    "section": "Other",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 8,
                    "reversedIndex": 2,
                    "pos": {
                        "left": 984.3773249999998,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": null,
                "isFlipped": false,
                "cardData": {
                    "id": "14d2979d-5728-42d7-a027-0eb1f754655d",
                    "name": "Talisman of Creativity",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Talisman of Creativity",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/b/f/bfe00640-e775-4b2e-91a8-081c7ec0125c.jpg?1743207377"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "R",
                        "U"
                    ],
                    "set": "tdc",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "800a5499-dd0f-444b-8f7d-cce15e4a4a11",
                "position": {
                    "section": "Mana",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 5,
                    "reversedIndex": 0,
                    "pos": {
                        "left": 493.504375,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": true,
                "isFlipped": false,
                "cardData": {
                    "id": "b2c6aa39-2d2a-459c-a555-fb48ba993373",
                    "name": "Island",
                    "type": "Land",
                    "Card type": "Basic Land — Island",
                    "face": {
                        "front": {
                            "name": "Island",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/1/f/1ff6acc9-581c-468f-894d-41f725da7f33.jpg?1743205101"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "U"
                    ],
                    "set": "tdm",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "5c7d3ddd-4057-4a1e-84b2-4753e3dd1e07",
                "position": {
                    "section": "Hand",
                    "pos": {
                        "left": 554.2650000000001,
                        "top": 507.75
                    },
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 0,
                    "reversedIndex": 5
                },
                "hiddenTo": {
                    "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6": true,
                    "fed75268-c816-48fd-8eb4-d5a87396332e": true,
                    "ef32f23f-a797-435e-94a5-58e371317c64": true
                },
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "ffc95093-24a2-4616-a44a-24788e8df9c8",
                    "name": "Trinket Mage",
                    "type": "Creature",
                    "Card type": "Creature — Human Wizard",
                    "face": {
                        "front": {
                            "name": "Trinket Mage",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/9/a/9a7800f7-95cd-4f5c-b054-4afad8924367.jpg?1712502961"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "ddu",
                    "isHorizontal": false,
                    "power": 2,
                    "toughness": 2,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "75e8f793-3e64-4301-8c3d-b96e166e1375",
                "position": {
                    "section": "Hand",
                    "pos": {
                        "left": 650.76,
                        "top": 507.75
                    },
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 1,
                    "reversedIndex": 4
                },
                "hiddenTo": {
                    "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6": true,
                    "fed75268-c816-48fd-8eb4-d5a87396332e": true,
                    "ef32f23f-a797-435e-94a5-58e371317c64": true
                },
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "c718911c-c955-4eb9-9e16-be4bd49a4e4e",
                    "name": "Volcanic Island",
                    "type": "Land",
                    "Card type": "Land — Island Mountain",
                    "face": {
                        "front": {
                            "name": "Volcanic Island",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/2/f/2f607e7e-30c0-45e9-8f61-bf6e9fe63f2b.jpg?1562904669"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "R",
                        "U"
                    ],
                    "set": "vma",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "c5c9cd5f-dd7f-4cdb-8a2b-7695df09db56",
                "position": {
                    "section": "Hand",
                    "pos": {
                        "left": 747.255,
                        "top": 507.75
                    },
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 2,
                    "reversedIndex": 3
                },
                "hiddenTo": {
                    "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6": true,
                    "fed75268-c816-48fd-8eb4-d5a87396332e": true,
                    "ef32f23f-a797-435e-94a5-58e371317c64": true
                },
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "0fd114c4-092b-4e28-b0dc-ef529f3bc73e",
                    "name": "Jeska's Will",
                    "type": "Sorcery",
                    "Card type": "Sorcery",
                    "face": {
                        "front": {
                            "name": "Jeska's Will",
                            "type": "Sorcery",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/9/9/99e0c371-1024-4432-9fd9-3bc29c8d38e4.jpg?1706240845"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "mkc",
                    "isHorizontal": false,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "68bd46d7-914d-4ea4-9056-e3f6f1284744",
                "position": {
                    "section": "Creatures",
                    "cardSize": {
                        "width": 14,
                        "height": 20
                    },
                    "index": 4,
                    "reversedIndex": 0,
                    "pos": {
                        "left": 1105.661875,
                        "top": 4.59375
                    }
                },
                "hiddenTo": {},
                "isTapped": null,
                "isFlipped": false,
                "cardData": {
                    "id": "fb81e4d3-1d8c-4779-be62-87cf49277e51",
                    "name": "Birgi, God of Storytelling // Harnfel, Horn of Bounty",
                    "type": "Creature",
                    "Card type": "Legendary Creature — God // Legendary Artifact",
                    "face": {
                        "front": {
                            "name": "Birgi, God of Storytelling",
                            "type": "Creature",
                            "cost": 3,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/4/4/44657ab1-0a6a-4a5f-9688-86f239083821.jpg?1631048969"
                        },
                        "back": {
                            "name": "Harnfel, Horn of Bounty",
                            "type": "Artifact",
                            "cost": 3,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/back/4/4/44657ab1-0a6a-4a5f-9688-86f239083821.jpg?1631048969"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "khm",
                    "isHorizontal": false,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "88dd7361-de10-4c2a-ad9d-3c488df118d6",
                "position": {
                    "section": "Discard",
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 0,
                    "reversedIndex": 7,
                    "pos": {
                        "left": 1364.03125,
                        "top": 360.703125
                    }
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "2550c2ae-834d-46e7-9ab4-d7bf7bfa6a78",
                    "name": "This Town Ain't Big Enough",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "This Town Ain't Big Enough",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/b/b/bb206e27-da4d-4abe-9d8c-6d18c5f2f52a.jpg?1712355528"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "otj",
                    "isHorizontal": false,
                    "cost": 5
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "9b8e329b-3858-49f1-8bec-a7ecfb7cbf21",
                "position": {
                    "section": "Discard",
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 1,
                    "reversedIndex": 6,
                    "pos": {
                        "left": 1364.03125,
                        "top": 360.703125
                    }
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "956381ba-6d37-4a8a-846c-bad79222dbee",
                    "name": "Force of Will",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Force of Will",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/8/9/89f612d6-7c59-4a7b-a87d-45f789e88ba5.jpg?1675199280"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "dmr",
                    "isHorizontal": false,
                    "cost": 5
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "83c4ad2c-8cfa-4b6d-9303-bb45e6203991",
                "position": {
                    "section": "Other",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 10,
                    "reversedIndex": 0,
                    "pos": {
                        "left": 848.3437499999997,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": null,
                "isFlipped": false,
                "cardData": {
                    "id": "994bc16d-fdc6-475c-96df-beeb4d5aa03e",
                    "name": "Mystic Forge",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Mystic Forge",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/b/c/bc0de77a-c503-4000-9eb5-aa28a5e91082.jpg?1690005636"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "cmm",
                    "isHorizontal": false,
                    "cost": 4
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "8d937b6e-1925-4a11-8835-741debd6ea81",
                "position": {
                    "section": "Hand",
                    "pos": {
                        "left": 843.75,
                        "top": 507.75
                    },
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 3,
                    "reversedIndex": 2
                },
                "hiddenTo": {
                    "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6": true,
                    "fed75268-c816-48fd-8eb4-d5a87396332e": true,
                    "ef32f23f-a797-435e-94a5-58e371317c64": true
                },
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "23467047-6dba-4498-b783-1ebc4f74b8c2",
                    "name": "Ancient Tomb",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Ancient Tomb",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/b/d/bd3d4b4b-cf31-4f89-8140-9650edb03c7b.jpg?1582753000"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "uma",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "164b72a6-2099-4d86-9508-89efb03ad863",
                "position": {
                    "section": "Hand",
                    "pos": {
                        "left": 940.245,
                        "top": 507.75
                    },
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 4,
                    "reversedIndex": 1
                },
                "hiddenTo": {
                    "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6": true,
                    "fed75268-c816-48fd-8eb4-d5a87396332e": true,
                    "ef32f23f-a797-435e-94a5-58e371317c64": true
                },
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "af1553eb-4f9f-4335-9078-56649bd8d8fc",
                    "name": "Brass's Tunnel-Grinder // Tecutlan, the Searing Rift",
                    "type": "Artifact",
                    "Card type": "Legendary Artifact // Legendary Land — Cave",
                    "face": {
                        "front": {
                            "name": "Brass's Tunnel-Grinder",
                            "type": "Artifact",
                            "cost": 3,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/d/6/d61d8895-7f2e-4c77-951f-4f1a49e96f57.jpg?1699044234"
                        },
                        "back": {
                            "name": "Tecutlan, the Searing Rift",
                            "type": "Land",
                            "cost": 3,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/back/d/6/d61d8895-7f2e-4c77-951f-4f1a49e96f57.jpg?1699044234"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "lci",
                    "isHorizontal": false,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "f9662380-b7a2-4a8e-adcc-def2c6f7cf2b",
                "position": {
                    "section": "Hand",
                    "pos": {
                        "left": 1036.74,
                        "top": 507.75
                    },
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 5,
                    "reversedIndex": 0
                },
                "hiddenTo": {
                    "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6": true,
                    "fed75268-c816-48fd-8eb4-d5a87396332e": true,
                    "ef32f23f-a797-435e-94a5-58e371317c64": true
                },
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "ed1e5d24-c8a8-48fe-a88f-1003ad432477",
                    "name": "Hurkyl's Recall",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Hurkyl's Recall",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/7/3/73edeaaa-6a87-4cf1-b013-bab9a7bb94d9.jpg?1562263763"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "mm2",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            }
        ],
        "deck": [
            {
                "id": "b782b47c-ca2d-4823-80f0-df4f63363f38",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "a8abd966-de7b-46a3-8ac7-8747ab35653a",
                    "name": "Wheel of Fortune",
                    "type": "Sorcery",
                    "Card type": "Sorcery",
                    "face": {
                        "front": {
                            "name": "Wheel of Fortune",
                            "type": "Sorcery",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/2/5/2597050f-6b1b-474e-aa16-33fd154628ca.jpg?1562902580"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "vma",
                    "isHorizontal": false,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "8cdcaa11-ad51-4791-aa4f-4d745f8088e4",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "31cefc9d-cc13-4b32-a1f8-edbcaf35aa3b",
                    "name": "Retract",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Retract",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/4/e/4e09a443-0a00-458a-b351-8cb188e9218c.jpg?1562636784"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "dst",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "11af28ce-f361-47ec-ad18-7927cd7b2955",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "234a734b-ba28-4f1b-9d01-3c3e7d516590",
                    "name": "An Offer You Can't Refuse",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "An Offer You Can't Refuse",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/a/8/a829747f-cf9b-4d81-ba66-9f0630ed4565.jpg?1730489199"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "fdn",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "5553c87f-049e-4f6c-bfe3-1f53b6b2ce64",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "026f4a4b-eedd-44e1-9d37-ca4fb8d6db98",
                    "name": "Fiery Islet",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Fiery Islet",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/a/3/a3aab13c-9d9d-4507-ae5d-da979990ae1b.jpg?1562202552"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "R",
                        "U"
                    ],
                    "set": "mh1",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "143ded09-d4ef-4d4b-8ad4-f40526dbf95a",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "8c95d823-6bbd-4484-8f38-b1bb20403085",
                    "name": "Filter Out",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Filter Out",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/a/8/a81a9eb1-240b-40fd-9282-0f5abec63449.jpg?1684340498"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "mat",
                    "isHorizontal": false,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "b34eecbb-331d-4daf-a109-90542d2cca65",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "d0ee5bdc-2b69-4b73-9a20-ffcc18783b29",
                    "name": "Mana Confluence",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Mana Confluence",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/5/0/504a69eb-3c2d-4bb1-b117-252b15acf0c2.jpg?1593096534"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "jou",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "12387237-2108-455d-a4e2-16ecaec93f71",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "86bf58f2-7f25-4e10-b797-25e0e8e67769",
                    "name": "Flusterstorm",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Flusterstorm",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/f/9/f900eeb7-7c45-44bc-ad3a-0bbe594ecf50.jpg?1562856071"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "ima",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "279bc5b8-cf9f-4399-9c5c-46a3824fc336",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "1d67f5ff-1fce-45e5-b6a1-416c569351e2",
                    "name": "Gitaxian Probe",
                    "type": "Sorcery",
                    "Card type": "Sorcery",
                    "face": {
                        "front": {
                            "name": "Gitaxian Probe",
                            "type": "Sorcery",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/9/9/995486ce-58bb-4753-a812-0ca73ef1a235.jpg?1562880052"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "nph",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "e7358d24-bc37-4780-88a6-5fb0b65b64b7",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "f2fcef65-4873-4b1f-a257-b8648097c990",
                    "name": "Helm of Awakening",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Helm of Awakening",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/e/9/e9e4ff9c-6244-43e1-b569-32a270c4e014.jpg?1675200994"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "dmr",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "82e5e3eb-92b5-4486-83fe-8553ef42573e",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "2c10cae2-951a-4f4f-94e4-8713b58d07dd",
                    "name": "Pyrite Spellbomb",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Pyrite Spellbomb",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/0/8/088c801d-381f-403b-aeb7-fbbfafee99bf.jpg?1599709775"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "R"
                    ],
                    "set": "2xm",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "1addd2cc-8849-4223-b182-f6d92f875576",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "697bcfe1-ecbf-42a1-bfc7-0766d48ca56b",
                    "name": "Dockside Extortionist",
                    "type": "Creature",
                    "Card type": "Creature — Goblin Pirate",
                    "face": {
                        "front": {
                            "name": "Dockside Extortionist",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/9/e/9e2e3efb-75cb-430f-b9f4-cb58f3aeb91b.jpg?1727093692"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "2x2",
                    "isHorizontal": false,
                    "power": 1,
                    "toughness": 2,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "49debb7c-fd39-4159-86df-2237018e3c45",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "0895c9b7-ae7d-4bb3-af17-3b75deb50a25",
                    "name": "Command Tower",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Command Tower",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/5/f/5fc770b6-03ac-45c3-a2ca-bd508096384e.jpg?1743206097"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "tdc",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "05026c8d-cc16-4245-a836-faebe6718a1c",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "f25351e3-539b-4bbc-b92d-6480acf4d722",
                    "name": "City of Brass",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "City of Brass",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/b/e/bed4a63d-632a-4a3a-b35f-f8e155237d27.jpg?1673149483"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "2x2",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "3a92dd60-615f-42c4-bddf-e65d26fc8cc2",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "8d0adc5c-3fdd-4e22-b783-5651f8e57b65",
                    "name": "Final Fortune",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Final Fortune",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/f/b/fb80afc3-4887-42a0-afb2-7fa997981fb2.jpg?1562251808"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "7ed",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "280bb0c2-3205-4159-8a59-2813d16b92eb",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "37108cd4-bbab-4ce3-9ed6-f60e8422e703",
                    "name": "Ragavan, Nimble Pilferer",
                    "type": "Creature",
                    "Card type": "Legendary Creature — Monkey Pirate",
                    "face": {
                        "front": {
                            "name": "Ragavan, Nimble Pilferer",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/a/9/a9738cda-adb1-47fb-9f4c-ecd930228c4d.jpg?1681963138"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "mh2",
                    "isHorizontal": false,
                    "power": 2,
                    "toughness": 1,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "f2fb5a29-4084-47e3-a159-39a6a29dd37c",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "0bc7f093-bef0-4f1a-852c-4b75ebf54838",
                    "name": "Arcane Signet",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Arcane Signet",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/9/3/935644d4-a140-4f24-b8ab-d5e79a682a9b.jpg?1743206090"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "tdc",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "7b571e98-808d-476d-a771-480236cbb874",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "8cb36a67-9206-4665-a03f-64f52ba559c4",
                    "name": "Into the Flood Maw",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Into the Flood Maw",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/5/0/50b9575a-53d9-4df7-b86c-cda021107d3f.jpg?1721426097"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "blb",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "c81f4581-1636-45e8-9ab8-4f2a36389abc",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "c5acf2a5-40f4-433d-a74d-1cb56c521464",
                    "name": "Arid Mesa",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Arid Mesa",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/2/5/25ac5405-df7b-4097-914a-022cb18e20d4.jpg?1738703645"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "mh2",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "ab8aa855-1562-49c2-937f-2e8ec9c08246",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "55a519b4-61cb-448a-875b-4d6dbe00580f",
                    "name": "Spire of Industry",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Spire of Industry",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/9/0/90b845fd-5b22-4196-9cba-00c7e1b44509.jpg?1706241253"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "mkc",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "cbbab5f7-ea9b-441a-ae09-bd9640fa1c38",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "de2440de-e948-4811-903c-0bbe376ff64d",
                    "name": "Mox Opal",
                    "type": "Artifact",
                    "Card type": "Legendary Artifact",
                    "face": {
                        "front": {
                            "name": "Mox Opal",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/5/6/56001a36-126b-4c08-af98-a6cc4d84210e.jpg?1734350253"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "2xm",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "917f55b5-b2c3-46b2-9550-89732aa5e343",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "96b87445-6362-4a17-91b2-cbf203fd03fd",
                    "name": "Etherium Sculptor",
                    "type": "Creature",
                    "Card type": "Artifact Creature — Vedalken Artificer",
                    "face": {
                        "front": {
                            "name": "Etherium Sculptor",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/e/d/ed796f1a-683d-4ac5-af48-ca58a557a74f.jpg?1651655702"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "nec",
                    "isHorizontal": false,
                    "power": 1,
                    "toughness": 2,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "f88a1f07-1721-4d1b-9cdb-d420bd4e00ba",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "13575cf9-65c1-4861-b21e-eb2155e07766",
                    "name": "Sensei's Divining Top",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Sensei's Divining Top",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/e/5/e5142b7a-e580-4737-a4aa-2590f6610ceb.jpg?1673149430"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "2x2",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "379995e0-72f0-4a33-8bd3-b93da5b02644",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "2c63e4e1-89d2-4bc6-a232-94e75c4b1c8a",
                    "name": "Mana Crypt",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Mana Crypt",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/4/d/4d960186-4559-4af0-bd22-63baa15f8939.jpg?1727298349"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "2xm",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "0d8a2338-2fad-4ab5-bc8f-18c1d8bd93a9",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "ec3d4466-547c-4e02-b1b5-a156ec4637e9",
                    "name": "Chrome Mox",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Chrome Mox",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/f/3/f340cbf7-5bbe-45b9-a4bf-d1caa500ff93.jpg?1739403657"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "2xm",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "e6a9885e-31d7-4a9b-aa8b-bcf0312bbf2a",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "17039058-822d-409f-938c-b727a366ba63",
                    "name": "Steam Vents",
                    "type": "Land",
                    "Card type": "Land — Island Mountain",
                    "face": {
                        "front": {
                            "name": "Steam Vents",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/6/6/66d618f4-443c-4a6c-8cbd-5d4ea96b2cd4.jpg?1702429824"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "R",
                        "U"
                    ],
                    "set": "rvr",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "a232081c-7219-402b-9c8a-839feccc72be",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "27e0948b-9916-473b-8d8c-a51bdfbc7457",
                    "name": "Underworld Breach",
                    "type": "Enchantment",
                    "Card type": "Enchantment",
                    "face": {
                        "front": {
                            "name": "Underworld Breach",
                            "type": "Enchantment",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/0/e/0e51d796-7279-4c06-87f0-37adbdaa41df.jpg?1743418992"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "thb",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "3d189742-51b8-4d92-b24c-df28561bf244",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "1a0770e6-b093-4439-baff-6889a50ba12e",
                    "name": "Mental Misstep",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Mental Misstep",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/6/1/61e9c6df-1c84-4eab-9076-a4feb6347c10.jpg?1566819829"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "nph",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "48a16386-5d5a-44db-87fa-dd2a1f01c679",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "f3c7af78-a77d-4134-82a2-a5ce84285a84",
                    "name": "Flooded Strand",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Flooded Strand",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/8/f/8f85e12c-196b-4459-b81f-0c9c854e9f57.jpg?1717012985"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "mh3",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "0c618448-6a4b-4a2e-88c5-18f8d7414c74",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "32e5339e-9e4f-46f8-b305-f9d6d3ba8bb5",
                    "name": "Lotus Petal",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Lotus Petal",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/f/8/f85ab5f9-508e-45de-8fa1-ce1f16552ffc.jpg?1701537448"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "tpr",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "d381cad4-6def-40f6-80b3-a46711e9de4c",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "e3570ac7-c593-40e3-bbd6-ec3da6d8158d",
                    "name": "Training Center",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Training Center",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/7/8/78a39d22-5e3b-4ba0-b728-dbf16b61fc8f.jpg?1690000040"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "R",
                        "U"
                    ],
                    "set": "cmm",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "17b4097b-abe6-4d1a-87af-d0e7ad0f0c38",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "422e1869-134f-463d-9fa1-86b66a998b3e",
                    "name": "Fabricate",
                    "type": "Sorcery",
                    "Card type": "Sorcery",
                    "face": {
                        "front": {
                            "name": "Fabricate",
                            "type": "Sorcery",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/4/4/44e49332-b1e1-4b88-b508-516b55c67a1d.jpg?1707508001"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "hop",
                    "isHorizontal": false,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "c2e65167-4257-49fd-8bbe-61221d97b235",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "ea734863-5793-49d6-b10e-109432aec0a3",
                    "name": "Artist's Talent",
                    "type": "Enchantment",
                    "Card type": "Enchantment — Class",
                    "face": {
                        "front": {
                            "name": "Artist's Talent",
                            "type": "Enchantment",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/8/b/8b9e51d9-189b-4dd6-87cb-628ea6373e81.jpg?1721426571"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "blb",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "5b1dd8e6-01c9-4b84-95e5-6a0af4a5f096",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "a54f0869-94c8-42af-9080-166efb9486a4",
                    "name": "Gamble",
                    "type": "Sorcery",
                    "Card type": "Sorcery",
                    "face": {
                        "front": {
                            "name": "Gamble",
                            "type": "Sorcery",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/8/e/8e37fae5-ddd0-4e16-8581-71579f89d9c5.jpg?1745319947"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "dmr",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "220ed15f-1301-4cc5-ae0e-0e5eed463df8",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "736892cb-a34b-4bb9-b56c-e26e3db207a2",
                    "name": "Mana Vault",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Mana Vault",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/c/1/c1a31d52-a407-4ded-bfca-cc812f11afa0.jpg?1673149384"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "2x2",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "c75423f8-5c54-42ea-96d8-8e0d273e782d",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "11db299a-0918-46a3-b39b-16acc3f4e281",
                    "name": "Experimental Synthesizer",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Experimental Synthesizer",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/c/4/c47931c9-685d-4b83-8299-bc347224b4e8.jpg?1654567579"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "neo",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "6a538b73-2242-4b35-a6ee-ae8ae8661de1",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "53236dd7-845a-444c-96d5-f41ed7325d8f",
                    "name": "Rhystic Study",
                    "type": "Enchantment",
                    "Card type": "Enchantment",
                    "face": {
                        "front": {
                            "name": "Rhystic Study",
                            "type": "Enchantment",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/d/6/d6914dba-0d27-4055-ac34-b3ebf5802221.jpg?1600698439"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "jmp",
                    "isHorizontal": false,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "cf170a21-fe14-40b5-a6aa-7d2c63a4861c",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "89ca686a-7c72-4d8f-9290-e89635624a83",
                    "name": "Cavern of Souls",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Cavern of Souls",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/3/a/3aad15a2-8a1b-4460-9b06-e85863081878.jpg?1706884128"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "lci",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "8adb20df-d907-423f-b1f6-6b067bec29a7",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "6191a7eb-04b5-47e6-a31f-43f9aa91d4d7",
                    "name": "Artificer's Assistant",
                    "type": "Creature",
                    "Card type": "Creature — Bird",
                    "face": {
                        "front": {
                            "name": "Artificer's Assistant",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/d/e/deadf867-b999-49b2-88d8-91da975a3cc5.jpg?1562744145"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "dom",
                    "isHorizontal": false,
                    "power": 1,
                    "toughness": 1,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "0023a6ce-4d74-483d-8969-f0113ed70dea",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "ae120613-97d6-4393-b39d-c3e6c076f5d6",
                    "name": "Deflecting Swat",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Deflecting Swat",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/b/4/b4b36435-55b3-4615-8812-af41d4fc64d9.jpg?1745319946"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "cmm",
                    "isHorizontal": false,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "1654aaba-d69d-4cf8-a35e-5d268b765ee2",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "7a43bd27-fdd8-41f0-9bc4-92568f3408f1",
                    "name": "Mox Amber",
                    "type": "Artifact",
                    "Card type": "Legendary Artifact",
                    "face": {
                        "front": {
                            "name": "Mox Amber",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/6/6/66024e69-ad60-4c9a-a0ca-da138d33ad80.jpg?1685554120"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "dom",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "5827b422-d903-4d0c-80f3-9ec889b182c0",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "eb0d8093-5f93-4b25-9384-08f9731bfb28",
                    "name": "Spirebluff Canal",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Spirebluff Canal",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/5/9/59a04e16-a767-4112-ab01-6ca1b09c286c.jpg?1712356382"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "R",
                        "U"
                    ],
                    "set": "otj",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "12d85d47-6751-465e-8629-8dd6672fb227",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "6ad8011d-3471-4369-9d68-b264cc027487",
                    "name": "Sol Ring",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Sol Ring",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/7/b/7b0ccfd4-f118-4497-9c5a-54cf12000e16.jpg?1743206094"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "tdc",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "eb6f0935-5164-4d94-8d9a-3e1501bd9148",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "340bbe8b-e987-4c3e-ab4e-9dee63e57d4f",
                    "name": "Phyrexian Metamorph",
                    "type": "Creature",
                    "Card type": "Artifact Creature — Phyrexian Shapeshifter",
                    "face": {
                        "front": {
                            "name": "Phyrexian Metamorph",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/e/5/e5a1ff9e-fef2-4890-baf2-7bd0852ea0b9.jpg?1706240727"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "mkc",
                    "isHorizontal": false,
                    "power": 0,
                    "toughness": 0,
                    "cost": 4
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "d14cf1ef-6403-4f98-bd30-79f1c52f3c34",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "814e321d-16fd-4f7b-a8d8-2b089be76f2c",
                    "name": "Resculpt",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Resculpt",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/5/9/592c7819-7e53-4793-bc4f-3dd489a25d63.jpg?1689996566"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "cmm",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "9fd9f34c-2802-4de8-bf5e-08d140087ab4",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "95560508-7ac9-4be9-8a3f-3c7d5b52807b",
                    "name": "Fellwar Stone",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Fellwar Stone",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/c/e/ce55e00c-cd95-48eb-986e-edf5125f3534.jpg?1743207310"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "tdc",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "085790b0-e431-4e07-b1d2-0b6610edb23d",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "4924b3a4-a218-4783-8a4d-82361fdecc78",
                    "name": "Riverglide Pathway // Lavaglide Pathway",
                    "type": "Land",
                    "Card type": "Land // Land",
                    "face": {
                        "front": {
                            "name": "Riverglide Pathway",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/2/6/2668ac91-6cda-4f81-a08d-4fc5f9cb35b2.jpg?1669839416"
                        },
                        "back": {
                            "name": "Lavaglide Pathway",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/back/2/6/2668ac91-6cda-4f81-a08d-4fc5f9cb35b2.jpg?1669839416"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "R",
                        "U"
                    ],
                    "set": "znr",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "5149b527-e3cf-4c4e-bfca-b5537d87176a",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "ee6099b0-fb1f-42f1-b862-7708c6e36d05",
                    "name": "Lion's Eye Diamond",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Lion's Eye Diamond",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/7/5/758f95f8-bcb0-43ae-b474-56ebd855951e.jpg?1590511899"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "vma",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "736e56a7-1b38-4059-a265-e58b27566ca3",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "dbe792f9-22be-4972-b418-99a6190c4421",
                    "name": "Transmute Artifact",
                    "type": "Sorcery",
                    "Card type": "Sorcery",
                    "face": {
                        "front": {
                            "name": "Transmute Artifact",
                            "type": "Sorcery",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/2/8/2888553d-5ed0-4e47-8cc2-1491b5557c53.jpg?1562904620"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "me4",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "978bce71-6ec7-4aaf-8031-96acd000b161",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "e2ad4b4d-d5fe-4a64-9b40-296c8fc8bcce",
                    "name": "Jeweled Amulet",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Jeweled Amulet",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/1/e/1ec4975d-3ca8-45fd-9e6c-06650c6ac2e2.jpg?1562867848"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "me2",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "05fe94d3-1dba-4bd5-9d34-7d9840406bb2",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "bcc6eece-75ea-494c-b33a-d4477d504e0b",
                    "name": "Sink into Stupor // Soporific Springs",
                    "type": "Land",
                    "Card type": "Instant // Land",
                    "face": {
                        "front": {
                            "name": "Sink into Stupor",
                            "type": "Instant",
                            "cost": 3,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/5/3/5358b87a-1a29-426d-b165-40c97da2c14d.jpg?1717013194"
                        },
                        "back": {
                            "name": "Soporific Springs",
                            "type": "Land",
                            "cost": 3,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/back/5/3/5358b87a-1a29-426d-b165-40c97da2c14d.jpg?1717013194"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "mh3",
                    "isHorizontal": false,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "a06c8f91-5636-4467-bf11-d8741fac9b7a",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "229d6627-1292-4ae1-8849-b0f956fa6540",
                    "name": "Grim Monolith",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Grim Monolith",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/9/d/9ddc9fe1-17c8-4e1d-aeb8-c4214e881280.jpg?1562863767"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "ulg",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "6e8cb8bb-a0d6-43de-b4a7-5d7758a14c50",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "1573f7f9-672c-421a-b1ac-3d0d8aea59ca",
                    "name": "Tormod's Crypt",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Tormod's Crypt",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/7/5/752bf493-5839-47e8-95f2-6d8201907428.jpg?1675201100"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "dmr",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "6749174d-0c1e-4732-8603-2799d77511b6",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "f3c5978a-70fa-431f-933b-b954bd0db0ea",
                    "name": "Mox Diamond",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Mox Diamond",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/b/f/bf9fecfd-d122-422f-bd0a-5bf69b434dfe.jpg?1562431287"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "tpr",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "2350b085-dd0f-4280-808d-3be42a426b3d",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "0c016ccc-a341-4b76-87ba-69c639d2746d",
                    "name": "Dragon's Rage Channeler",
                    "type": "Creature",
                    "Card type": "Creature — Human Shaman",
                    "face": {
                        "front": {
                            "name": "Dragon's Rage Channeler",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/4/c/4ced112a-e775-4f97-97b3-74877e9dce12.jpg?1626096503"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "mh2",
                    "isHorizontal": false,
                    "power": 1,
                    "toughness": 1,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "266bbd12-1a19-477a-8836-6d79048bd967",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "8ddfc283-c9b4-41a5-af88-cf0068e986cc",
                    "name": "Swan Song",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Swan Song",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/9/d/9d968dde-c406-48ef-a1ab-373aebc24693.jpg?1562412350"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "c16",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "fd90df4c-9b16-4c75-ba2f-abaf9a672e9c",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "0ffce5e0-6b1d-4d1a-9318-1a1a219df532",
                    "name": "Glaring Fleshraker",
                    "type": "Creature",
                    "Card type": "Creature — Eldrazi Drone",
                    "face": {
                        "front": {
                            "name": "Glaring Fleshraker",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/8/0/80c2a3c7-1486-4ff9-88ec-79ec67a437f8.jpg?1717011246"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "mh3",
                    "isHorizontal": false,
                    "power": 2,
                    "toughness": 2,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "3ef151c4-7c48-4aad-802c-fb5665ae0986",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "63afc3d1-7653-476e-838f-fc18d4a62a21",
                    "name": "Mishra's Bauble",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Mishra's Bauble",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/4/5/45bbbf9b-8fee-4c32-a513-02dac6ac8a39.jpg?1669300401"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "2xm",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "32af175d-eeef-40c8-b589-dc9189e400c4",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "0fe16212-66c3-4e45-a641-7391e9b2e304",
                    "name": "Shivan Reef",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Shivan Reef",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/a/6/a67ddfae-746f-4952-8064-7d48f9f22981.jpg?1743207735"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "R",
                        "U"
                    ],
                    "set": "tdc",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "73d71992-c07c-45e2-9187-9222eb94e27d",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "ef86989d-ce80-4e55-aece-7d11710eeffa",
                    "name": "Polluted Delta",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Polluted Delta",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/6/e/6e288374-2b71-4ace-b1d2-a19fee6cb4af.jpg?1717013017"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "mh3",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "15296867-dad2-455d-aaa6-19cf5c651c79",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "464c0150-3dbc-403b-9ada-fef25ab1f29d",
                    "name": "Brain Freeze",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Brain Freeze",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/3/a/3a2d7cf9-dddb-4de3-b4f2-c52e3ec8fb4b.jpg?1562906772"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "vma",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "201c31bb-c387-446c-952f-50d62ad9e9e6",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "7c8e4f29-53e0-4242-8ef8-7a9476dce178",
                    "name": "Candy Trail",
                    "type": "Artifact",
                    "Card type": "Artifact — Food Clue",
                    "face": {
                        "front": {
                            "name": "Candy Trail",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/1/a/1a860925-d912-49e5-9ddc-41ab26916bb3.jpg?1692939848"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "woe",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "c4f3c000-6dac-4c08-a03f-5bce57016892",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "bdeb440d-a714-40e8-9038-f651e6ae45fb",
                    "name": "Springleaf Drum",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Springleaf Drum",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/f/3/f3b3869b-6da1-4b01-a2e7-2018d478b6e5.jpg?1599709959"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "2xm",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            },
            {
                "id": "f17c0e2c-7a27-45fc-97e8-dac5e562ed73",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "09dd85aa-47bc-4713-a9b9-8b52ff2285ed",
                    "name": "Misty Rainforest",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Misty Rainforest",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/8/8/88231c0d-0cc8-44ec-bf95-81d1710ac141.jpg?1738703648"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "mh2",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "faa9bafc-3ce4-49e1-b19c-72054e5ff63b",
                "isHorizontal": false
            }
        ],
        "deckTopCardHiddenTo": {
            "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6": true,
            "fed75268-c816-48fd-8eb4-d5a87396332e": true,
            "ef32f23f-a797-435e-94a5-58e371317c64": true,
            "faa9bafc-3ce4-49e1-b19c-72054e5ff63b": true
        },
        "cardsLinks": [],
        "profileData": {
            "name": "PiouPiou",
            "avatar": "https://i.imgur.com/7QmYdYk.jpeg",
            "background": "https://i.imgur.com/G8ceHWa.jpeg"
        },
        "playerCounters": [
            {
                "id": "2dfa932d-e541-4f60-aa2a-6359dd0adabe",
                "value": 40
            },
            {
                "id": "6ffe9a41-40cc-40e9-bfec-0eab77fc780f",
                "value": 0
            }
        ],
        "playerTokens": {},
        "playerNotes": "Player1: 0\nPlayer2: 0\nPlayer3: 0",
        "refreshCount": 1
    },
    "fed75268-c816-48fd-8eb4-d5a87396332e": {
        "visibleCards": [
            {
                "id": "e721af24-fde5-4733-a1ab-3608750d246a",
                "position": {
                    "section": "Creatures",
                    "cardSize": {
                        "width": 14,
                        "height": 20
                    },
                    "index": 2,
                    "reversedIndex": 2,
                    "pos": {
                        "left": 848.3418750000001,
                        "top": 4.59375
                    }
                },
                "hiddenTo": {},
                "isTapped": null,
                "isFlipped": false,
                "cardData": {
                    "id": "5fac139a-07d3-4e6c-98e3-d98b199f7a6f",
                    "name": "Young Pyromancer",
                    "type": "Creature",
                    "Card type": "Creature — Human Shaman",
                    "face": {
                        "front": {
                            "name": "Young Pyromancer",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/c/0/c0d74ecd-a595-4012-81b4-083264b40c94.jpg?1743206054"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "tdc",
                    "isHorizontal": false,
                    "power": 2,
                    "toughness": 1,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "b56a2295-915e-404e-8108-22acc1e3b800",
                "position": {
                    "section": "Mana",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 3,
                    "reversedIndex": 8,
                    "pos": {
                        "left": 260.85970454545463,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": true,
                "isFlipped": false,
                "cardData": {
                    "id": "43985bbc-a0f6-4812-984e-392bc8562633",
                    "name": "Blood Crypt",
                    "type": "Land",
                    "Card type": "Land — Swamp Mountain",
                    "face": {
                        "front": {
                            "name": "Blood Crypt",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/0/9/0994aef4-b341-45f4-8881-523565a5956e.jpg?1702429795"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "B",
                        "R"
                    ],
                    "set": "rvr",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "4f1a8d86-3d96-4250-8eb4-a7e1264bb186",
                "position": {
                    "section": "Mana",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 2,
                    "reversedIndex": 9,
                    "pos": {
                        "left": 199.02626136363642,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": true,
                "isFlipped": false,
                "cardData": {
                    "id": "390f1b56-264e-4336-83be-dc1fe79bfdcf",
                    "name": "Smoldering Marsh",
                    "type": "Land",
                    "Card type": "Land — Swamp Mountain",
                    "face": {
                        "front": {
                            "name": "Smoldering Marsh",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/a/3/a357b4ad-adb8-4db7-a4dc-2fc3f6b7e2d5.jpg?1743207747"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "B",
                        "R"
                    ],
                    "set": "tdc",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "91b6f39a-9a4b-408b-b320-0e4c5c63263c",
                "position": {
                    "section": "Creatures",
                    "cardSize": {
                        "width": 14,
                        "height": 20
                    },
                    "index": 0,
                    "reversedIndex": 4,
                    "pos": {
                        "left": 591.021875,
                        "top": 4.59375
                    }
                },
                "hiddenTo": {},
                "isTapped": null,
                "isFlipped": false,
                "cardData": {
                    "id": "c6bdaf76-6a03-4695-9c4b-f040e73435af",
                    "name": "Guttersnipe",
                    "type": "Creature",
                    "Card type": "Creature — Goblin Shaman",
                    "face": {
                        "front": {
                            "name": "Guttersnipe",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/f/d/fd5be605-c7c3-4c0b-a68e-65452b27d3ce.jpg?1743206688"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "tdc",
                    "isHorizontal": false,
                    "power": 2,
                    "toughness": 2,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "a913f696-bf6b-456a-8825-efbea2b71703",
                "position": {
                    "section": "Discard",
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 10,
                    "reversedIndex": 3,
                    "pos": {
                        "left": 1364.03125,
                        "top": 360.703125
                    }
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "30377bd5-99ab-4888-9ea7-e5a069b527e8",
                    "name": "Return the Favor",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Return the Favor",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/a/9/a9cc02d1-799d-42aa-9bc2-4c05452b63b4.jpg?1712860602"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "otj",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "f294cb23-8301-4d10-bc18-90a6310e5f64",
                "position": {
                    "section": "Mana",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 1,
                    "reversedIndex": 10,
                    "pos": {
                        "left": 137.1928181818182,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": true,
                "isFlipped": false,
                "cardData": {
                    "id": "a3fb7228-e76b-4e96-a40e-20b5fed75685",
                    "name": "Mountain",
                    "type": "Land",
                    "Card type": "Basic Land — Mountain",
                    "face": {
                        "front": {
                            "name": "Mountain",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/b/f/bfa10a88-12e0-4b79-80bb-6f4620277e20.jpg?1743205117"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "R"
                    ],
                    "set": "tdm",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "9977d15b-6359-4f5a-974d-8b1bc8f31ad3",
                "position": {
                    "section": "Other",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 0,
                    "reversedIndex": 3,
                    "pos": {
                        "left": 1528.511625,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": null,
                "isFlipped": false,
                "cardData": {
                    "id": "6ad8011d-3471-4369-9d68-b264cc027487",
                    "name": "Sol Ring",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Sol Ring",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/7/b/7b0ccfd4-f118-4497-9c5a-54cf12000e16.jpg?1743206094"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "tdc",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "78b55a00-17a0-4eb7-ba32-0914daf4425f",
                "position": {
                    "section": "Commander",
                    "pos": {
                        "left": 75.359375,
                        "top": 4.59375
                    },
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 0,
                    "reversedIndex": 0
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "e86c965b-ac10-4fff-b682-dddd6d9747c6",
                    "name": "Judith, Carnage Connoisseur",
                    "type": "Creature",
                    "Card type": "Legendary Creature — Human Shaman",
                    "face": {
                        "front": {
                            "name": "Judith, Carnage Connoisseur",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/3/e/3eaa19ce-cace-499e-8b23-ef9e56b23700.jpg?1706242185"
                        }
                    },
                    "Colors": [
                        "B",
                        "R"
                    ],
                    "Color identity": [
                        "B",
                        "R"
                    ],
                    "set": "mkm",
                    "isHorizontal": false,
                    "power": 3,
                    "toughness": 4,
                    "cost": 5
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "7ae509f4-aef0-42fa-8e72-8a1e1cac9c38",
                "position": {
                    "section": "Mana",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 0,
                    "reversedIndex": 11,
                    "pos": {
                        "left": 75.359375,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": true,
                "isFlipped": false,
                "cardData": {
                    "id": "5004b84a-33b7-4f6f-b2c2-7086b9087535",
                    "name": "Graven Cairns",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Graven Cairns",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/7/4/74a13fea-4f48-428b-b42b-4ba63d4752ed.jpg?1726285427"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "B",
                        "R"
                    ],
                    "set": "dsc",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "db570b9f-c9c3-4521-b7e5-ef4048a92906",
                "position": {
                    "section": "Discard",
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 11,
                    "reversedIndex": 2,
                    "pos": {
                        "left": 1364.03125,
                        "top": 360.703125
                    }
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "f718e507-296b-4f22-842b-5fb91322069b",
                    "name": "Feign Death",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Feign Death",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/3/2/32af7061-fca6-4a06-be3c-01881e6b96f7.jpg?1627704817"
                        }
                    },
                    "Colors": [
                        "B"
                    ],
                    "Color identity": [
                        "B"
                    ],
                    "set": "afr",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "e5ddf2dc-66f7-4212-b0be-8dee40fd13d7",
                "position": {
                    "section": "Discard",
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 12,
                    "reversedIndex": 1,
                    "pos": {
                        "left": 1364.03125,
                        "top": 360.703125
                    }
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "025939a0-424a-41bf-8fc9-2ef9ea5485f7",
                    "name": "Fire Covenant",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Fire Covenant",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/f/5/f5ac3712-6bcd-4d93-a944-520a2092bee4.jpg?1559592388"
                        }
                    },
                    "Colors": [
                        "B",
                        "R"
                    ],
                    "Color identity": [
                        "B",
                        "R"
                    ],
                    "set": "me1",
                    "isHorizontal": false,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "9bd5fb09-58b9-4822-b001-ae3e652d6bb3",
                "position": {
                    "section": "Discard",
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 13,
                    "reversedIndex": 0,
                    "pos": {
                        "left": 1364.03125,
                        "top": 360.703125
                    }
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "3d6fa57a-aa53-4b5c-b8af-a7612c823117",
                    "name": "Faithless Looting",
                    "type": "Sorcery",
                    "Card type": "Sorcery",
                    "face": {
                        "front": {
                            "name": "Faithless Looting",
                            "type": "Sorcery",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/c/4/c43aeb5a-8bdc-4aa9-89d1-156f97ac38aa.jpg?1743206665"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "tdc",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "b6d27fff-a03d-40f3-aae5-52c039905d5e",
                "position": {
                    "section": "Other",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 1,
                    "reversedIndex": 2,
                    "pos": {
                        "left": 1444.882625,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": null,
                "isFlipped": false,
                "cardData": {
                    "id": "0c6ce7c9-316b-4171-a8fa-ca26af1eecb7",
                    "name": "Dark Tutelage",
                    "type": "Enchantment",
                    "Card type": "Enchantment",
                    "face": {
                        "front": {
                            "name": "Dark Tutelage",
                            "type": "Enchantment",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/9/e/9ec3dd9f-3969-4fd7-97f7-e9868eb19a64.jpg?1562469514"
                        }
                    },
                    "Colors": [
                        "B"
                    ],
                    "Color identity": [
                        "B"
                    ],
                    "set": "m11",
                    "isHorizontal": false,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "e472c5d4-b3e0-41e4-b669-506fef045643",
                "position": {
                    "section": "Other",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 3,
                    "reversedIndex": 0,
                    "pos": {
                        "left": 1277.624625,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": null,
                "isFlipped": false,
                "cardData": {
                    "id": "0bc7f093-bef0-4f1a-852c-4b75ebf54838",
                    "name": "Arcane Signet",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Arcane Signet",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/9/3/935644d4-a140-4f24-b8ab-d5e79a682a9b.jpg?1743206090"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "tdc",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "49b81087-8c01-4416-836b-449467eed52f",
                "position": {
                    "section": "Mana",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 6,
                    "reversedIndex": 5,
                    "pos": {
                        "left": 446.36003409090927,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": true,
                "isFlipped": false,
                "cardData": {
                    "id": "5c87e2fa-77f1-4978-b25f-f14d227301d1",
                    "name": "Foreboding Ruins",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Foreboding Ruins",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/e/9/e9236b80-fa80-4da3-a357-db7749011499.jpg?1726285414"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "B",
                        "R"
                    ],
                    "set": "dsc",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "68d1c231-5230-43f8-930c-9505cac414b5",
                "position": {
                    "section": "Mana",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 4,
                    "reversedIndex": 7,
                    "pos": {
                        "left": 322.69314772727284,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": true,
                "isFlipped": false,
                "cardData": {
                    "id": "56719f6a-1a6c-4c0a-8d21-18f7d7350b68",
                    "name": "Swamp",
                    "type": "Land",
                    "Card type": "Basic Land — Swamp",
                    "face": {
                        "front": {
                            "name": "Swamp",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/f/0/f0bfdb9e-318f-4acd-9fbd-41b98a8875d6.jpg?1743205109"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "B"
                    ],
                    "set": "tdm",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "6daceec5-dd43-4b22-9474-e68e3e6e8afc",
                "position": {
                    "section": "Other",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 2,
                    "reversedIndex": 1,
                    "pos": {
                        "left": 1361.2536249999998,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": null,
                "isFlipped": false,
                "cardData": {
                    "id": "9965d9c5-2ebf-4a6c-930e-55c5890979be",
                    "name": "Thought Vessel",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Thought Vessel",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/7/1/71b11bf4-35ab-4028-961f-5180a12dac82.jpg?1728610326"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "dsc",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "f7087a9d-501d-4802-96cc-d85a159da735",
                "position": {
                    "section": "Discard",
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 7,
                    "reversedIndex": 6,
                    "pos": {
                        "left": 1364.03125,
                        "top": 360.703125
                    }
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "b45e35df-9032-4482-89a6-c7c50c6d0a79",
                    "name": "Corrupted Conviction",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Corrupted Conviction",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/8/0/8046f892-3317-4ef7-9cf7-97b9060540c8.jpg?1712355575"
                        }
                    },
                    "Colors": [
                        "B"
                    ],
                    "Color identity": [
                        "B"
                    ],
                    "set": "otj",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "772fc3f6-32f2-4335-9185-04a548955b67",
                "position": {
                    "section": "Discard",
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 9,
                    "reversedIndex": 4,
                    "pos": {
                        "left": 1364.03125,
                        "top": 360.703125
                    }
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "5825997b-10d7-4a36-972c-a80ddd90b8ed",
                    "name": "Feed the Swarm",
                    "type": "Sorcery",
                    "Card type": "Sorcery",
                    "face": {
                        "front": {
                            "name": "Feed the Swarm",
                            "type": "Sorcery",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/a/7/a776f96b-01bf-430a-b1ad-9f4651070610.jpg?1743206491"
                        }
                    },
                    "Colors": [
                        "B"
                    ],
                    "Color identity": [
                        "B"
                    ],
                    "set": "tdc",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "70cddc72-2e15-4bb8-a642-b64147824094",
                "position": {
                    "section": "Discard",
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 8,
                    "reversedIndex": 5,
                    "pos": {
                        "left": 1364.03125,
                        "top": 360.703125
                    }
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "a5cbd257-c836-493e-bb1a-76242619dea2",
                    "name": "Big Score",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Big Score",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/c/0/c0b2deb2-b198-4d79-8cef-5b8a2577c992.jpg?1743206622"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "tdc",
                    "isHorizontal": false,
                    "cost": 4
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "89c0e203-a037-4bf2-a894-fc7ee4b5883b",
                "position": {
                    "section": "Mana",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 7,
                    "reversedIndex": 4,
                    "pos": {
                        "left": 508.1934772727275,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": true,
                "isFlipped": false,
                "cardData": {
                    "id": "a3fb7228-e76b-4e96-a40e-20b5fed75685",
                    "name": "Mountain",
                    "type": "Land",
                    "Card type": "Basic Land — Mountain",
                    "face": {
                        "front": {
                            "name": "Mountain",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/b/f/bfa10a88-12e0-4b79-80bb-6f4620277e20.jpg?1743205117"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "R"
                    ],
                    "set": "tdm",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "3a925f8e-676c-4c81-9cf0-08e7a60322e2",
                "position": {
                    "section": "Mana",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 5,
                    "reversedIndex": 6,
                    "pos": {
                        "left": 384.52659090909106,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": true,
                "isFlipped": false,
                "cardData": {
                    "id": "56719f6a-1a6c-4c0a-8d21-18f7d7350b68",
                    "name": "Swamp",
                    "type": "Land",
                    "Card type": "Basic Land — Swamp",
                    "face": {
                        "front": {
                            "name": "Swamp",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/f/0/f0bfdb9e-318f-4acd-9fbd-41b98a8875d6.jpg?1743205109"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "B"
                    ],
                    "set": "tdm",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "24ffc891-52ca-497b-88ac-140254daa115",
                "position": {
                    "section": "Discard",
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 6,
                    "reversedIndex": 7,
                    "pos": {
                        "left": 1364.03125,
                        "top": 360.703125
                    }
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "99fd4b51-1698-4168-9366-a6ea2df22361",
                    "name": "Electrickery",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Electrickery",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/5/e/5ed81ee8-d5e4-4127-876e-9bff81f9c726.jpg?1562787062"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "rtr",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "c724fee2-1be6-4731-8459-ca094267572d",
                "position": {
                    "section": "Discard",
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 2,
                    "reversedIndex": 11,
                    "pos": {
                        "left": 1364.03125,
                        "top": 360.703125
                    }
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "7a2484a9-04fd-41a0-8224-610c1c07ed10",
                    "name": "Blasphemous Act",
                    "type": "Sorcery",
                    "Card type": "Sorcery",
                    "face": {
                        "front": {
                            "name": "Blasphemous Act",
                            "type": "Sorcery",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/2/c/2c971698-c0e4-4b68-808f-a3d1a73d80e4.jpg?1743206629"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "tdc",
                    "isHorizontal": false,
                    "cost": 9
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "2e0e8f08-5d73-437a-8af9-87530024a9df",
                "position": {
                    "section": "Discard",
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 5,
                    "reversedIndex": 8,
                    "pos": {
                        "left": 1364.03125,
                        "top": 360.703125
                    }
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "df020a47-1784-479b-9882-be77b7f30950",
                    "name": "Highway Robbery",
                    "type": "Sorcery",
                    "Card type": "Sorcery",
                    "face": {
                        "front": {
                            "name": "Highway Robbery",
                            "type": "Sorcery",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/3/1/31a88429-9204-4a23-a7a8-babbd6bab79f.jpg?1712355775"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "otj",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "79c2b230-e09c-4ef1-8c38-a43c0091710a",
                "position": {
                    "section": "Creatures",
                    "cardSize": {
                        "width": 14,
                        "height": 20
                    },
                    "index": 1,
                    "reversedIndex": 3,
                    "pos": {
                        "left": 719.681875,
                        "top": 4.59375
                    }
                },
                "hiddenTo": {},
                "isTapped": null,
                "isFlipped": false,
                "cardData": {
                    "id": "fb81e4d3-1d8c-4779-be62-87cf49277e51",
                    "name": "Birgi, God of Storytelling // Harnfel, Horn of Bounty",
                    "type": "Creature",
                    "Card type": "Legendary Creature — God // Legendary Artifact",
                    "face": {
                        "front": {
                            "name": "Birgi, God of Storytelling",
                            "type": "Creature",
                            "cost": 3,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/4/4/44657ab1-0a6a-4a5f-9688-86f239083821.jpg?1631048969"
                        },
                        "back": {
                            "name": "Harnfel, Horn of Bounty",
                            "type": "Artifact",
                            "cost": 3,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/back/4/4/44657ab1-0a6a-4a5f-9688-86f239083821.jpg?1631048969"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "khm",
                    "isHorizontal": false,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "840acbba-0501-4c48-b2c7-dc66a614e940",
                "position": {
                    "section": "Mana",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 10,
                    "reversedIndex": 1,
                    "pos": {
                        "left": 693.6938068181822,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": true,
                "isFlipped": false,
                "cardData": {
                    "id": "a3fb7228-e76b-4e96-a40e-20b5fed75685",
                    "name": "Mountain",
                    "type": "Land",
                    "Card type": "Basic Land — Mountain",
                    "face": {
                        "front": {
                            "name": "Mountain",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/b/f/bfa10a88-12e0-4b79-80bb-6f4620277e20.jpg?1743205117"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "R"
                    ],
                    "set": "tdm",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "1818d394-0dc4-41e4-9882-00d072f92dbc",
                "position": {
                    "section": "Discard",
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 3,
                    "reversedIndex": 10,
                    "pos": {
                        "left": 1364.03125,
                        "top": 360.703125
                    }
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "dcf503b5-c7ef-49e5-87ed-3b8758197446",
                    "name": "Wail of the Nim",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Wail of the Nim",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/a/8/a8c32faa-c6d1-418a-aed6-ccc5849daa1f.jpg?1562153645"
                        }
                    },
                    "Colors": [
                        "B"
                    ],
                    "Color identity": [
                        "B"
                    ],
                    "set": "mrd",
                    "isHorizontal": false,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "5ca24e66-9ac3-4e3a-aaa2-9e381b4bdb98",
                "position": {
                    "section": "Discard",
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 4,
                    "reversedIndex": 9,
                    "pos": {
                        "left": 1364.03125,
                        "top": 360.703125
                    }
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "8d35cef8-a52d-45fb-8f5f-cccea26826d0",
                    "name": "Wyll's Reversal",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Wyll's Reversal",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/3/d/3d8df219-1da0-4311-b9bb-c74b5fa55293.jpg?1674136904"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "clb",
                    "isHorizontal": false,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "7a45c683-71bd-4750-bf94-25ea4927cf46",
                "position": {
                    "section": "Creatures",
                    "cardSize": {
                        "width": 14,
                        "height": 20
                    },
                    "index": 4,
                    "reversedIndex": 0,
                    "pos": {
                        "left": 1105.661875,
                        "top": 4.59375
                    }
                },
                "hiddenTo": {},
                "isTapped": null,
                "isFlipped": false,
                "cardData": {
                    "id": "d3b7b541-6f05-46c1-8031-c848c4bd4635",
                    "name": "Ojer Axonil, Deepest Might // Temple of Power",
                    "type": "Creature",
                    "Card type": "Legendary Creature — God // Land",
                    "face": {
                        "front": {
                            "name": "Ojer Axonil, Deepest Might",
                            "type": "Creature",
                            "cost": 4,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/5/0/50f8e2b6-98c7-4f28-bb39-e1fbe841f1ee.jpg?1699044315"
                        },
                        "back": {
                            "name": "Temple of Power",
                            "type": "Land",
                            "cost": 4,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/back/5/0/50f8e2b6-98c7-4f28-bb39-e1fbe841f1ee.jpg?1699044315"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "lci",
                    "isHorizontal": false,
                    "cost": 4
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "14961170-8ac7-49a6-ba99-857487189bb5",
                "position": {
                    "section": "Mana",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 9,
                    "reversedIndex": 2,
                    "pos": {
                        "left": 631.860363636364,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": true,
                "isFlipped": false,
                "cardData": {
                    "id": "56719f6a-1a6c-4c0a-8d21-18f7d7350b68",
                    "name": "Swamp",
                    "type": "Land",
                    "Card type": "Basic Land — Swamp",
                    "face": {
                        "front": {
                            "name": "Swamp",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/f/0/f0bfdb9e-318f-4acd-9fbd-41b98a8875d6.jpg?1743205109"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "B"
                    ],
                    "set": "tdm",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "4aea90dc-9404-46d6-8aaf-b8d89c8dae14",
                "position": {
                    "section": "Mana",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 8,
                    "reversedIndex": 3,
                    "pos": {
                        "left": 570.0269204545457,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": true,
                "isFlipped": false,
                "cardData": {
                    "id": "c23e5b80-08d2-4e24-9908-fe2aa4f30f6f",
                    "name": "Reliquary Tower",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Reliquary Tower",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/6/b/6be3be55-7f9d-4a4c-b916-a1cb64f833c8.jpg?1743207700"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "tdc",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "7715eed8-0146-4a80-96a2-ffc8a08cfc17",
                "position": {
                    "section": "Creatures",
                    "cardSize": {
                        "width": 14,
                        "height": 20
                    },
                    "index": 3,
                    "reversedIndex": 1,
                    "pos": {
                        "left": 977.001875,
                        "top": 4.59375
                    }
                },
                "hiddenTo": {},
                "isTapped": null,
                "isFlipped": false,
                "cardData": {
                    "id": "8c3495bf-02e7-4ad9-949d-92eb3d2b662a",
                    "name": "Torbran, Thane of Red Fell",
                    "type": "Creature",
                    "Card type": "Legendary Creature — Dwarf Noble",
                    "face": {
                        "front": {
                            "name": "Torbran, Thane of Red Fell",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/7/9/79f591cd-d277-4ba5-b1bf-1c09cac9cb8a.jpg?1572490491"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "eld",
                    "isHorizontal": false,
                    "power": 2,
                    "toughness": 4,
                    "cost": 4
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "b02ef4fb-d59e-4003-a971-2d81d6e6ecd4",
                "position": {
                    "section": "Discard",
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 1,
                    "reversedIndex": 12,
                    "pos": {
                        "left": 1364.03125,
                        "top": 360.703125
                    }
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "3e5402bf-ce7b-4c23-9333-0acdcf349caf",
                    "name": "Fanatical Offering",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Fanatical Offering",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/d/8/d896dd52-b134-4b55-ab91-ccb05ecc50f4.jpg?1699044130"
                        }
                    },
                    "Colors": [
                        "B"
                    ],
                    "Color identity": [
                        "B"
                    ],
                    "set": "lci",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "5d5e08d7-2efb-4ca5-aa20-e3606b0871a0",
                "position": {
                    "section": "Discard",
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 0,
                    "reversedIndex": 13,
                    "pos": {
                        "left": 1364.03125,
                        "top": 360.703125
                    }
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "8b061702-1bc3-45aa-a758-446b25034801",
                    "name": "Undying Malice",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Undying Malice",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/9/7/97b3cf11-e352-4ee1-8c03-13898f576ef9.jpg?1737710887"
                        }
                    },
                    "Colors": [
                        "B"
                    ],
                    "Color identity": [
                        "B"
                    ],
                    "set": "fdn",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "5a417e72-dc19-4567-9b01-b0e0a53e94f1",
                "position": {
                    "section": "Mana",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 11,
                    "reversedIndex": 0,
                    "pos": {
                        "left": 755.5272500000004,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": null,
                "isFlipped": false,
                "cardData": {
                    "id": "a3fb7228-e76b-4e96-a40e-20b5fed75685",
                    "name": "Mountain",
                    "type": "Land",
                    "Card type": "Basic Land — Mountain",
                    "face": {
                        "front": {
                            "name": "Mountain",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/b/f/bfa10a88-12e0-4b79-80bb-6f4620277e20.jpg?1743205117"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "R"
                    ],
                    "set": "tdm",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "f869a315-4fde-440f-83a0-872f2c900920",
                "position": {
                    "section": "Hand",
                    "pos": {
                        "left": 409.52250000000004,
                        "top": 507.75
                    },
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 0,
                    "reversedIndex": 8
                },
                "hiddenTo": {
                    "ef32f23f-a797-435e-94a5-58e371317c64": true,
                    "faa9bafc-3ce4-49e1-b19c-72054e5ff63b": true,
                    "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6": true
                },
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "1d9aeaaa-66f6-41cb-9bac-162d6fd8662c",
                    "name": "Talisman of Indulgence",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Talisman of Indulgence",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/d/a/daf69185-96cf-4523-be1d-1fe90fc63ab7.jpg?1726285334"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "B",
                        "R"
                    ],
                    "set": "dsc",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "42f7ac1a-9746-4e53-b5a6-fc4b2b57fbb6",
                "position": {
                    "section": "Hand",
                    "pos": {
                        "left": 506.01750000000004,
                        "top": 507.75
                    },
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 1,
                    "reversedIndex": 7
                },
                "hiddenTo": {
                    "ef32f23f-a797-435e-94a5-58e371317c64": true,
                    "faa9bafc-3ce4-49e1-b19c-72054e5ff63b": true,
                    "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6": true
                },
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "4457ed35-7c10-48c8-9776-456485fdf070",
                    "name": "Lightning Bolt",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Lightning Bolt",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/7/7/77c6fa74-5543-42ac-9ead-0e890b188e99.jpg?1706239968"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "clu",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "318d2ab9-2025-4b8e-be18-5c82c8758aeb",
                "position": {
                    "section": "Hand",
                    "pos": {
                        "left": 602.5125,
                        "top": 507.75
                    },
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 2,
                    "reversedIndex": 6
                },
                "hiddenTo": {
                    "ef32f23f-a797-435e-94a5-58e371317c64": true,
                    "faa9bafc-3ce4-49e1-b19c-72054e5ff63b": true,
                    "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6": true
                },
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "81a398ee-e534-43b7-88fe-45155d6aba3a",
                    "name": "Eviscerator's Insight",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Eviscerator's Insight",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/b/0/b00573bd-5bbb-4531-a0bb-a40f62b92b88.jpg?1717011960"
                        }
                    },
                    "Colors": [
                        "B"
                    ],
                    "Color identity": [
                        "B"
                    ],
                    "set": "mh3",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "38cbf8bc-674c-4d27-b793-d6207f244610",
                "position": {
                    "section": "Hand",
                    "pos": {
                        "left": 699.0074999999999,
                        "top": 507.75
                    },
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 3,
                    "reversedIndex": 5
                },
                "hiddenTo": {
                    "ef32f23f-a797-435e-94a5-58e371317c64": true,
                    "faa9bafc-3ce4-49e1-b19c-72054e5ff63b": true,
                    "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6": true
                },
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "c6207f6a-a624-4754-88f5-dbe700c841ff",
                    "name": "Sign in Blood",
                    "type": "Sorcery",
                    "Card type": "Sorcery",
                    "face": {
                        "front": {
                            "name": "Sign in Blood",
                            "type": "Sorcery",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/b/8/b89d9372-8682-4a61-a003-8bccfbb6cbb4.jpg?1726284903"
                        }
                    },
                    "Colors": [
                        "B"
                    ],
                    "Color identity": [
                        "B"
                    ],
                    "set": "dsc",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "a163b169-358f-4da4-9136-87472e3df571",
                "position": {
                    "section": "Hand",
                    "pos": {
                        "left": 795.5025,
                        "top": 507.75
                    },
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 4,
                    "reversedIndex": 4
                },
                "hiddenTo": {
                    "ef32f23f-a797-435e-94a5-58e371317c64": true,
                    "faa9bafc-3ce4-49e1-b19c-72054e5ff63b": true,
                    "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6": true
                },
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "a145ff8c-5812-4bcb-bd16-9839dc25121d",
                    "name": "Storm-Kiln Artist",
                    "type": "Creature",
                    "Card type": "Creature — Dwarf Shaman",
                    "face": {
                        "front": {
                            "name": "Storm-Kiln Artist",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/1/b/1b8c1345-4279-4e29-b58c-efacccb8e47f.jpg?1743206800"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "tdc",
                    "isHorizontal": false,
                    "power": 2,
                    "toughness": 2,
                    "cost": 4
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "4d0f7f8f-f320-44a3-9e69-1b3fc0418a7f",
                "position": {
                    "section": "Hand",
                    "pos": {
                        "left": 891.9975,
                        "top": 507.75
                    },
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 5,
                    "reversedIndex": 3
                },
                "hiddenTo": {
                    "ef32f23f-a797-435e-94a5-58e371317c64": true,
                    "faa9bafc-3ce4-49e1-b19c-72054e5ff63b": true,
                    "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6": true
                },
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "71c52bf5-2a5d-488e-8b15-7ef290e4b77d",
                    "name": "War Room",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "War Room",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/a/8/a824d5c0-cdd3-42e2-ac04-b8cada566163.jpg?1706241294"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "mkc",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "dbf1bb96-7b87-4174-ab07-2c4143f3b662",
                "position": {
                    "section": "Hand",
                    "pos": {
                        "left": 988.4925,
                        "top": 507.75
                    },
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 6,
                    "reversedIndex": 2
                },
                "hiddenTo": {
                    "ef32f23f-a797-435e-94a5-58e371317c64": true,
                    "faa9bafc-3ce4-49e1-b19c-72054e5ff63b": true,
                    "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6": true
                },
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "9097243a-39fa-4e18-8316-c0e57699c783",
                    "name": "Tectonic Hazard",
                    "type": "Sorcery",
                    "Card type": "Sorcery",
                    "face": {
                        "front": {
                            "name": "Tectonic Hazard",
                            "type": "Sorcery",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/5/2/5204c781-f568-4c7f-b3f7-ce4dd678689b.jpg?1699044348"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "lci",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "6d8b2fab-5c87-41d9-a1b8-9283a6b391c5",
                "position": {
                    "section": "Hand",
                    "pos": {
                        "left": 1084.9875,
                        "top": 507.75
                    },
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 7,
                    "reversedIndex": 1
                },
                "hiddenTo": {
                    "ef32f23f-a797-435e-94a5-58e371317c64": true,
                    "faa9bafc-3ce4-49e1-b19c-72054e5ff63b": true,
                    "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6": true
                },
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "a3fb7228-e76b-4e96-a40e-20b5fed75685",
                    "name": "Mountain",
                    "type": "Land",
                    "Card type": "Basic Land — Mountain",
                    "face": {
                        "front": {
                            "name": "Mountain",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/b/f/bfa10a88-12e0-4b79-80bb-6f4620277e20.jpg?1743205117"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "R"
                    ],
                    "set": "tdm",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "916fe00f-f16b-4132-822e-697fe9e6d362",
                "position": {
                    "section": "Hand",
                    "pos": {
                        "left": 1181.4825,
                        "top": 507.75
                    },
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 8,
                    "reversedIndex": 0
                },
                "hiddenTo": {
                    "ef32f23f-a797-435e-94a5-58e371317c64": true,
                    "faa9bafc-3ce4-49e1-b19c-72054e5ff63b": true,
                    "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6": true
                },
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "111889d4-bcca-4b1f-ad48-3077e2f5136f",
                    "name": "Fiery Inscription",
                    "type": "Enchantment",
                    "Card type": "Enchantment",
                    "face": {
                        "front": {
                            "name": "Fiery Inscription",
                            "type": "Enchantment",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/8/c/8c321159-43e5-40fc-9f0c-4ecc4f6cfd20.jpg?1686968925"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "ltr",
                    "isHorizontal": false,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            }
        ],
        "deck": [
            {
                "id": "35cef3c7-3fce-462f-ac70-867675f36b8a",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "63398c02-6fb1-481d-9d9f-81063532fbc0",
                    "name": "Dragonskull Summit",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Dragonskull Summit",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/2/4/243ae383-f77d-4942-ae73-61f991131e03.jpg?1743207534"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "B",
                        "R"
                    ],
                    "set": "tdc",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "31535b0f-220d-48aa-bfc5-9cdc919e4493",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "b24ed296-e17d-4e36-8a86-a370868b0136",
                    "name": "Cast into the Fire",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Cast into the Fire",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/2/e/2ef878cb-27b6-47d8-ad11-bd20529b0e7e.jpg?1686968832"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "ltr",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "f192d18b-6db8-4890-80a2-8a6260af0f22",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "1cb0610b-a731-42c2-b93f-0a29f63cebf4",
                    "name": "Thrill of Possibility",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Thrill of Possibility",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/8/8/882b348c-076b-41d8-b505-063480636669.jpg?1730489377"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "fdn",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "66e654b1-6422-4694-9fd6-7cbb02d5bb0a",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "086b2564-9114-4ba2-94fd-b490f98f38a7",
                    "name": "Chain Reaction",
                    "type": "Sorcery",
                    "Card type": "Sorcery",
                    "face": {
                        "front": {
                            "name": "Chain Reaction",
                            "type": "Sorcery",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/9/2/92ca793e-a54a-4e8f-a87d-f0dc4f178412.jpg?1674141900"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "clb",
                    "isHorizontal": false,
                    "cost": 4
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "295949fa-dfee-4541-8c5a-3961352d357b",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "457af74a-02b3-4659-846d-63e482667f34",
                    "name": "Deadly Dispute",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Deadly Dispute",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/b/2/b22ef77b-67a3-45d3-9d18-12b7b124cbf4.jpg?1743419051"
                        }
                    },
                    "Colors": [
                        "B"
                    ],
                    "Color identity": [
                        "B"
                    ],
                    "set": "tdc",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "d3a054e2-039a-4a67-8a7b-a59f0b4f4e8f",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "3567c3c8-b3c7-45b7-935b-b1fdbc973720",
                    "name": "Vandalblast",
                    "type": "Sorcery",
                    "Card type": "Sorcery",
                    "face": {
                        "front": {
                            "name": "Vandalblast",
                            "type": "Sorcery",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/e/7/e781b55f-6388-4ab8-be74-7c56eaba1c4d.jpg?1712354517"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "otc",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "30f3c557-88d4-4d5b-9b81-fd0baf023546",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "3dc364f3-3094-4660-80ca-9418588c7fde",
                    "name": "Mithril Coat",
                    "type": "Artifact",
                    "Card type": "Legendary Artifact — Equipment",
                    "face": {
                        "front": {
                            "name": "Mithril Coat",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/0/f/0fd1fc09-a09d-45e6-8a07-3a8a83b4e6ec.jpg?1686970224"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "ltr",
                    "isHorizontal": false,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "cc1bf526-94b8-4282-8084-aad57da4f8ce",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "94f0a572-e91c-4b56-a5d1-6cbbeabd210d",
                    "name": "Infernal Grasp",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Infernal Grasp",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/a/8/a8b6ef8c-3c8c-4b37-9122-6188591e3a65.jpg?1743206504"
                        }
                    },
                    "Colors": [
                        "B"
                    ],
                    "Color identity": [
                        "B"
                    ],
                    "set": "tdc",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "7284ecd4-47f7-4cf0-a7ca-a1ea906e1127",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "53f7c868-b03e-4fc2-8dcf-a75bbfa3272b",
                    "name": "Dark Ritual",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Dark Ritual",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/9/5/95f27eeb-6f14-4db3-adb9-9be5ed76b34b.jpg?1628801678"
                        }
                    },
                    "Colors": [
                        "B"
                    ],
                    "Color identity": [
                        "B"
                    ],
                    "set": "a25",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "ba66b29f-c028-4e07-a1af-0d483485d570",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "f9db72dc-9a5b-48a4-a86e-7464d9a2166a",
                    "name": "Abrade",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Abrade",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/4/c/4c2a1b4e-858c-47a3-be89-9275e48d5475.jpg?1743206610"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "tdc",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "44c84c6a-8f86-46fd-b5db-4fe700c97c36",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "1861e642-21d5-4232-89f3-b5557f2946c1",
                    "name": "Phyrexian Tower",
                    "type": "Land",
                    "Card type": "Legendary Land",
                    "face": {
                        "front": {
                            "name": "Phyrexian Tower",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/0/b/0b47f6d2-9f65-47a4-bfc4-15619befe53d.jpg?1717013848"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "B"
                    ],
                    "set": "mh3",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "f5deb0cd-9778-4264-be39-5ee48b8feefc",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "56719f6a-1a6c-4c0a-8d21-18f7d7350b68",
                    "name": "Swamp",
                    "type": "Land",
                    "Card type": "Basic Land — Swamp",
                    "face": {
                        "front": {
                            "name": "Swamp",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/f/0/f0bfdb9e-318f-4acd-9fbd-41b98a8875d6.jpg?1743205109"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "B"
                    ],
                    "set": "tdm",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "6659ffa1-004c-4777-b5ae-f82e7f2224aa",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "e2a37967-4212-4553-9f77-bcb613405807",
                    "name": "Haunted Ridge",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Haunted Ridge",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/3/2/32f1e668-89b8-4f82-afc1-6c3efb1fef3b.jpg?1736468677"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "B",
                        "R"
                    ],
                    "set": "inr",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "8c6e8aed-3942-4b6f-b9c3-96a3326a9d4b",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "31bfb6ca-4455-4e3d-8f0f-e82f71990d61",
                    "name": "Hound of Urabrask",
                    "type": "Creature",
                    "Card type": "Creature — Phyrexian",
                    "face": {
                        "front": {
                            "name": "Hound of Urabrask",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/d/b/db23c148-3094-477f-8af9-9d6e02db1ec3.jpg?1726911024"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "unk",
                    "isHorizontal": false,
                    "power": 3,
                    "toughness": 3,
                    "cost": 5
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "ea4e7eb5-3e68-4d19-bb13-ee627f67a82c",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "56719f6a-1a6c-4c0a-8d21-18f7d7350b68",
                    "name": "Swamp",
                    "type": "Land",
                    "Card type": "Basic Land — Swamp",
                    "face": {
                        "front": {
                            "name": "Swamp",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/f/0/f0bfdb9e-318f-4acd-9fbd-41b98a8875d6.jpg?1743205109"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "B"
                    ],
                    "set": "tdm",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "95937d1d-d0f6-4fee-b7a0-291c82e38c05",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "1b3e841e-0f8f-467d-9983-f9b8d081a67f",
                    "name": "Mahadi, Emporium Master",
                    "type": "Creature",
                    "Card type": "Legendary Creature — Devil",
                    "face": {
                        "front": {
                            "name": "Mahadi, Emporium Master",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/c/3/c3da2b1a-76c5-4d36-bdf8-025b86f61eb5.jpg?1699601213"
                        }
                    },
                    "Colors": [
                        "B",
                        "R"
                    ],
                    "Color identity": [
                        "B",
                        "R"
                    ],
                    "set": "clb",
                    "isHorizontal": false,
                    "power": 3,
                    "toughness": 3,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "d78487c1-a75e-4680-910e-2358329d560a",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "56719f6a-1a6c-4c0a-8d21-18f7d7350b68",
                    "name": "Swamp",
                    "type": "Land",
                    "Card type": "Basic Land — Swamp",
                    "face": {
                        "front": {
                            "name": "Swamp",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/f/0/f0bfdb9e-318f-4acd-9fbd-41b98a8875d6.jpg?1743205109"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "B"
                    ],
                    "set": "tdm",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "6f624474-dfb9-450d-a1a3-ccc03a9624ba",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "584cf0fd-112a-4ca6-9c0e-1f3228a7d325",
                    "name": "Reckless Impulse",
                    "type": "Sorcery",
                    "Card type": "Sorcery",
                    "face": {
                        "front": {
                            "name": "Reckless Impulse",
                            "type": "Sorcery",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/6/9/6943c07f-ab0d-4f5a-bbe9-c0a83dc98546.jpg?1643591880"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "vow",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "5f676dd4-d159-4c77-b9c2-6e95a5429f1d",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "a3fb7228-e76b-4e96-a40e-20b5fed75685",
                    "name": "Mountain",
                    "type": "Land",
                    "Card type": "Basic Land — Mountain",
                    "face": {
                        "front": {
                            "name": "Mountain",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/b/f/bfa10a88-12e0-4b79-80bb-6f4620277e20.jpg?1743205117"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "R"
                    ],
                    "set": "tdm",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "fc2f2110-f526-427e-ba67-b43157d1e375",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "ff0ab867-b710-4b1a-baed-95fc3cf68f79",
                    "name": "Valakut Awakening // Valakut Stoneforge",
                    "type": "Land",
                    "Card type": "Instant // Land",
                    "face": {
                        "front": {
                            "name": "Valakut Awakening",
                            "type": "Instant",
                            "cost": 3,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/2/2/228e551e-023a-4c9a-8f32-58dae6ffdf7f.jpg?1604198379"
                        },
                        "back": {
                            "name": "Valakut Stoneforge",
                            "type": "Land",
                            "cost": 3,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/back/2/2/228e551e-023a-4c9a-8f32-58dae6ffdf7f.jpg?1604198379"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "znr",
                    "isHorizontal": false,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "e6523676-82e5-4c98-916f-25e037d9234b",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "365548fb-5acc-4a8a-b20b-26d28b7d029f",
                    "name": "Village Rites",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Village Rites",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/4/2/42ed35e9-51cd-468a-86a9-9412553cf50d.jpg?1736468066"
                        }
                    },
                    "Colors": [
                        "B"
                    ],
                    "Color identity": [
                        "B"
                    ],
                    "set": "inr",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "ddf1a1e2-9773-4a9d-bb6d-42de9c96233e",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "98e698ae-1a69-469c-9cfb-0e3fedeb71d4",
                    "name": "Enduring Tenacity",
                    "type": "Creature",
                    "Card type": "Enchantment Creature — Snake Glimmer",
                    "face": {
                        "front": {
                            "name": "Enduring Tenacity",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/d/5/d5756d4b-3068-412c-8643-880d3459151e.jpg?1726286203"
                        }
                    },
                    "Colors": [
                        "B"
                    ],
                    "Color identity": [
                        "B"
                    ],
                    "set": "dsk",
                    "isHorizontal": false,
                    "power": 4,
                    "toughness": 3,
                    "cost": 4
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "03f77165-47dc-411d-bf8b-be956123e184",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "95560508-7ac9-4be9-8a3f-3c7d5b52807b",
                    "name": "Fellwar Stone",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Fellwar Stone",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/c/e/ce55e00c-cd95-48eb-986e-edf5125f3534.jpg?1743207310"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "tdc",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "ea879f62-409f-4718-8c48-ed68af0904ee",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "eb414a8f-566f-4635-80a1-77b2e18ac8dc",
                    "name": "Runaway Steam-Kin",
                    "type": "Creature",
                    "Card type": "Creature — Elemental",
                    "face": {
                        "front": {
                            "name": "Runaway Steam-Kin",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/d/8/d8c9c111-fbc7-44e1-94bd-1ca164370623.jpg?1572893254"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "grn",
                    "isHorizontal": false,
                    "power": 1,
                    "toughness": 1,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "9a4d0cf3-ec17-44c3-a9f4-809307c94f30",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "09618da4-6e2d-4047-96d7-0576c0754e7d",
                    "name": "End the Festivities",
                    "type": "Sorcery",
                    "Card type": "Sorcery",
                    "face": {
                        "front": {
                            "name": "End the Festivities",
                            "type": "Sorcery",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/b/e/bec748e6-7245-4a71-aeee-cefed8346948.jpg?1643591154"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "vow",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "81cfe144-7730-46b6-b2a0-027daa9c4c4a",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "b44d5457-b4d6-4521-a25a-8ef96adba461",
                    "name": "Tor Wauki the Younger",
                    "type": "Creature",
                    "Card type": "Legendary Creature — Human Archer",
                    "face": {
                        "front": {
                            "name": "Tor Wauki the Younger",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/a/d/adea296b-b320-4588-9d6e-cbb5db7c39e3.jpg?1674174198"
                        }
                    },
                    "Colors": [
                        "B",
                        "R"
                    ],
                    "Color identity": [
                        "B",
                        "R"
                    ],
                    "set": "dmc",
                    "isHorizontal": false,
                    "power": 3,
                    "toughness": 3,
                    "cost": 5
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "cbe8e31c-9d1c-40e9-8c8b-d892257c6de3",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "56719f6a-1a6c-4c0a-8d21-18f7d7350b68",
                    "name": "Swamp",
                    "type": "Land",
                    "Card type": "Basic Land — Swamp",
                    "face": {
                        "front": {
                            "name": "Swamp",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/f/0/f0bfdb9e-318f-4acd-9fbd-41b98a8875d6.jpg?1743205109"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "B"
                    ],
                    "set": "tdm",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "2e3e1c86-2b39-461c-80bf-ffdbf4c93a3b",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "c8b143ad-43ec-4e0d-a440-e348daa31391",
                    "name": "Swiftfoot Boots",
                    "type": "Artifact",
                    "Card type": "Artifact — Equipment",
                    "face": {
                        "front": {
                            "name": "Swiftfoot Boots",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/1/9/1969b151-3192-4d35-80ca-c4e180601ec8.jpg?1743207367"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "tdc",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "73f500c8-0939-480a-9bd3-91892b6da419",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "a3fb7228-e76b-4e96-a40e-20b5fed75685",
                    "name": "Mountain",
                    "type": "Land",
                    "Card type": "Basic Land — Mountain",
                    "face": {
                        "front": {
                            "name": "Mountain",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/b/f/bfa10a88-12e0-4b79-80bb-6f4620277e20.jpg?1743205117"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "R"
                    ],
                    "set": "tdm",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "152259bc-319c-41a9-995a-53f9e4b5bea4",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "88bb91b5-2ccd-4ce9-8cd4-e54d63c12abf",
                    "name": "Coruscation Mage",
                    "type": "Creature",
                    "Card type": "Creature — Otter Wizard",
                    "face": {
                        "front": {
                            "name": "Coruscation Mage",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/d/c/dc2c1de0-6233-469a-be72-a050b97d2c8f.jpg?1721426600"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "blb",
                    "isHorizontal": false,
                    "power": 2,
                    "toughness": 2,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "8398b50d-f0f0-4d1e-8f6d-03f5a46fc8cd",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "a731e87b-8d99-4b64-8ee3-8e540d652366",
                    "name": "Malakir Rebirth // Malakir Mire",
                    "type": "Land",
                    "Card type": "Instant // Land",
                    "face": {
                        "front": {
                            "name": "Malakir Rebirth",
                            "type": "Instant",
                            "cost": 1,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/6/0/609d3ecf-f88d-4268-a8d3-4bf2bcf5df60.jpg?1604195984"
                        },
                        "back": {
                            "name": "Malakir Mire",
                            "type": "Land",
                            "cost": 1,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/back/6/0/609d3ecf-f88d-4268-a8d3-4bf2bcf5df60.jpg?1604195984"
                        }
                    },
                    "Colors": [
                        "B"
                    ],
                    "Color identity": [
                        "B"
                    ],
                    "set": "znr",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "530eb95a-48e6-45c3-a0d3-798acdfa99cc",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "2031b17c-0536-446f-a9aa-b46fe79b7ea7",
                    "name": "Canyon Slough",
                    "type": "Land",
                    "Card type": "Land — Swamp Mountain",
                    "face": {
                        "front": {
                            "name": "Canyon Slough",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/d/6/d66c52dd-2a69-4fe9-9037-f82b3e50ee54.jpg?1743207454"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "B",
                        "R"
                    ],
                    "set": "tdc",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "8c6c1814-b64c-49ac-848c-e47068b2e5a7",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "56719f6a-1a6c-4c0a-8d21-18f7d7350b68",
                    "name": "Swamp",
                    "type": "Land",
                    "Card type": "Basic Land — Swamp",
                    "face": {
                        "front": {
                            "name": "Swamp",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/f/0/f0bfdb9e-318f-4acd-9fbd-41b98a8875d6.jpg?1743205109"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "B"
                    ],
                    "set": "tdm",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "d032ec43-d6f3-4b87-91df-f3180d78fb49",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "380c367f-73ea-485f-a37b-5af0ba160893",
                    "name": "Not Dead After All",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Not Dead After All",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/d/0/d01a2b68-efe6-4027-846d-db7b19d9eef6.jpg?1692937773"
                        }
                    },
                    "Colors": [
                        "B"
                    ],
                    "Color identity": [
                        "B"
                    ],
                    "set": "woe",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "d6cf7ae9-44cd-4f24-8a88-0791c797204a",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "25dce517-ac0a-4577-89ed-04296c7c4069",
                    "name": "Sedgemoor Witch",
                    "type": "Creature",
                    "Card type": "Creature — Human Warlock",
                    "face": {
                        "front": {
                            "name": "Sedgemoor Witch",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/e/9/e900c1eb-968b-4046-b824-c167a7a5b682.jpg?1624591402"
                        }
                    },
                    "Colors": [
                        "B"
                    ],
                    "Color identity": [
                        "B"
                    ],
                    "set": "stx",
                    "isHorizontal": false,
                    "power": 3,
                    "toughness": 2,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "929c8c6c-d934-4f71-93e3-86216a3ab461",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "04e5e84f-8fd4-43ab-8f9d-5b24646f7ae5",
                    "name": "Raucous Theater",
                    "type": "Land",
                    "Card type": "Land — Swamp Mountain",
                    "face": {
                        "front": {
                            "name": "Raucous Theater",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/b/5/b598c93e-dae1-4d71-a9e4-917abf76d2d0.jpg?1706242355"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "B",
                        "R"
                    ],
                    "set": "mkm",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "69bf0711-5d7a-44e1-b698-55dc685ab030",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "acc842a4-26e8-435a-b717-c1043b581ff8",
                    "name": "Overmaster",
                    "type": "Sorcery",
                    "Card type": "Sorcery",
                    "face": {
                        "front": {
                            "name": "Overmaster",
                            "type": "Sorcery",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/2/8/28e812a8-66cf-4005-a647-780d49aa74a4.jpg?1675200116"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "dmr",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "e6bbfe18-b86c-451d-a33a-0612deac1372",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "bb8cccc8-e56f-42fa-a0d7-fc889b5e1c7b",
                    "name": "Boltwave",
                    "type": "Sorcery",
                    "Card type": "Sorcery",
                    "face": {
                        "front": {
                            "name": "Boltwave",
                            "type": "Sorcery",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/8/d/8d1ec351-5e70-4eb2-b590-6bff94ef8178.jpg?1730488883"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "fdn",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "b89e8d98-3b8d-449a-a250-612328903746",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "3adb7681-977f-4a32-9ec8-51481b958268",
                    "name": "Rakdos Signet",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Rakdos Signet",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/0/1/01cc9536-f710-4c47-9e3f-d7e83cc888f2.jpg?1726285319"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "B",
                        "R"
                    ],
                    "set": "dsc",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "09772025-c2d1-4e6f-b8ec-1d3e24e700e2",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "c13955b8-bad3-4f79-ad9f-11e214a1cab2",
                    "name": "Smash to Dust",
                    "type": "Sorcery",
                    "Card type": "Sorcery",
                    "face": {
                        "front": {
                            "name": "Smash to Dust",
                            "type": "Sorcery",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/7/4/747881c7-3788-4dd6-b78d-b2a5ded20e14.jpg?1673307504"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "dmu",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "e3285232-662c-410a-92d2-c621c7d28a43",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "819e1765-8325-4e6f-89c1-63ea86de369f",
                    "name": "Luxury Suite",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Luxury Suite",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/6/f/6fc5fc38-4054-4663-9061-df5455788c4a.jpg?1688006315"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "B",
                        "R"
                    ],
                    "set": "clb",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "56124da8-f3e1-4d2c-b6f7-b5aa9893b092",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "977c2f33-b622-4172-9efb-7f523becd32b",
                    "name": "Blazemire Verge",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Blazemire Verge",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/d/1/d151c8e2-d715-470d-868a-f45191db9fa0.jpg?1726286828"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "B",
                        "R"
                    ],
                    "set": "dsk",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "9641fe1b-99ed-4374-b736-8af9de145fab",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "7ffae8f8-3006-4969-a339-6d30678f87ea",
                    "name": "Night's Whisper",
                    "type": "Sorcery",
                    "Card type": "Sorcery",
                    "face": {
                        "front": {
                            "name": "Night's Whisper",
                            "type": "Sorcery",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/8/9/8971a739-5e5e-4175-83a1-6af66319a440.jpg?1726284444"
                        }
                    },
                    "Colors": [
                        "B"
                    ],
                    "Color identity": [
                        "B"
                    ],
                    "set": "dsc",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "ae6129f4-86e7-4adb-8689-7c2c08031062",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "9c58d241-4d9f-4b46-b8ee-f4587f9acfd6",
                    "name": "Plaza of Heroes",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Plaza of Heroes",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/a/2/a2cfcf67-f83c-43af-9e2d-5513fcdde835.jpg?1673308344"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "dmu",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "52cb661d-e8e3-4b0f-9161-877b057ed230",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "81036c9f-fe0a-45a7-bcd5-0d344f31055a",
                    "name": "Spikefield Hazard // Spikefield Cave",
                    "type": "Land",
                    "Card type": "Instant // Land",
                    "face": {
                        "front": {
                            "name": "Spikefield Hazard",
                            "type": "Instant",
                            "cost": 1,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/a/6/a69541db-3f4e-412f-aa8e-dec1e74f74dc.jpg?1604198070"
                        },
                        "back": {
                            "name": "Spikefield Cave",
                            "type": "Land",
                            "cost": 1,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/back/a/6/a69541db-3f4e-412f-aa8e-dec1e74f74dc.jpg?1604198070"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "znr",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "59695f69-8dda-4797-98e7-44354e01fab2",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "e580a229-e800-4746-9d37-c32fcef8de28",
                    "name": "Blightstep Pathway // Searstep Pathway",
                    "type": "Land",
                    "Card type": "Land // Land",
                    "face": {
                        "front": {
                            "name": "Blightstep Pathway",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/0/c/0ce39a19-f51d-4a35-ae80-5b82eb15fcff.jpg?1669839373"
                        },
                        "back": {
                            "name": "Searstep Pathway",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/back/0/c/0ce39a19-f51d-4a35-ae80-5b82eb15fcff.jpg?1669839373"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "B",
                        "R"
                    ],
                    "set": "khm",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "8a0c2282-8647-4b5b-8523-49d7931f5311",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "2fa94a07-c932-4f85-b6e0-a97d2b29eb52",
                    "name": "Electrostatic Field",
                    "type": "Creature",
                    "Card type": "Creature — Wall",
                    "face": {
                        "front": {
                            "name": "Electrostatic Field",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/2/1/21923a95-e65e-4f4a-81f8-fc0895beb107.jpg?1712354416"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "otc",
                    "isHorizontal": false,
                    "power": 0,
                    "toughness": 4,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "fe57c33e-3d07-45a7-baaf-26588ae38aa0",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "a3fb7228-e76b-4e96-a40e-20b5fed75685",
                    "name": "Mountain",
                    "type": "Land",
                    "Card type": "Basic Land — Mountain",
                    "face": {
                        "front": {
                            "name": "Mountain",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/b/f/bfa10a88-12e0-4b79-80bb-6f4620277e20.jpg?1743205117"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "R"
                    ],
                    "set": "tdm",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "0f63771d-9c9b-495c-9742-565ac9d62861",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "895f23a2-55b7-4cc0-8939-2efaaf097e6f",
                    "name": "Solphim, Mayhem Dominus",
                    "type": "Creature",
                    "Card type": "Legendary Creature — Phyrexian Horror",
                    "face": {
                        "front": {
                            "name": "Solphim, Mayhem Dominus",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/c/3/c3a0c7f3-7fb9-43de-a9af-96532c31e5ed.jpg?1675957113"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "one",
                    "isHorizontal": false,
                    "power": 5,
                    "toughness": 4,
                    "cost": 4
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "f452d6d4-cdf5-465c-babc-96dbbc7902d3",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "a3fb7228-e76b-4e96-a40e-20b5fed75685",
                    "name": "Mountain",
                    "type": "Land",
                    "Card type": "Basic Land — Mountain",
                    "face": {
                        "front": {
                            "name": "Mountain",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/b/f/bfa10a88-12e0-4b79-80bb-6f4620277e20.jpg?1743205117"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "R"
                    ],
                    "set": "tdm",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "bf1f0e36-faaf-4a85-9e95-f08f35d65d6c",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "4d18bcba-a346-445e-a182-6cc30b7e066d",
                    "name": "Ashnod's Altar",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Ashnod's Altar",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/3/c/3c0f7157-a375-499c-92c7-d47d2e95dbad.jpg?1689999385"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "cmm",
                    "isHorizontal": false,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "8b3bd00b-2793-4b85-8096-d6cb873d864c",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "c11e84a1-dbda-429b-8cd6-fd0deaefc689",
                    "name": "Demand Answers",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Demand Answers",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/e/c/eca092fc-7c67-4a73-989e-5297bbaaea76.jpg?1706241852"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "mkm",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "48fa9162-e3a5-4f33-ab44-f75e006f9881",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "a37387f0-9d57-49ff-aa38-2c6b359e8916",
                    "name": "Grab the Prize",
                    "type": "Sorcery",
                    "Card type": "Sorcery",
                    "face": {
                        "front": {
                            "name": "Grab the Prize",
                            "type": "Sorcery",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/5/0/50895202-f1a1-4840-a11a-55b78b8b5929.jpg?1726286361"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "dsk",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "0069bb08-3acf-4eb5-af0c-796abbf282bc",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "eadd9559-6dcb-4b96-8c95-58abddd0e120",
                    "name": "Kessig Flamebreather",
                    "type": "Creature",
                    "Card type": "Creature — Human Shaman",
                    "face": {
                        "front": {
                            "name": "Kessig Flamebreather",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/3/0/303ad78a-b02a-44dc-afe6-7f95781a5062.jpg?1643591531"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "vow",
                    "isHorizontal": false,
                    "power": 1,
                    "toughness": 3,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "a7c1e207-3d2b-4712-954e-5ac08f56f7cb",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "3656338d-ca08-465b-b09a-d8d8d1196eec",
                    "name": "Blazing Volley",
                    "type": "Sorcery",
                    "Card type": "Sorcery",
                    "face": {
                        "front": {
                            "name": "Blazing Volley",
                            "type": "Sorcery",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/3/a/3adc0288-acdf-4a99-9bfb-919cae1aeb69.jpg?1591227065"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "iko",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            },
            {
                "id": "916fe00f-f16b-4132-822e-697fe9e6d362",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "111889d4-bcca-4b1f-ad48-3077e2f5136f",
                    "name": "Fiery Inscription",
                    "type": "Enchantment",
                    "Card type": "Enchantment",
                    "face": {
                        "front": {
                            "name": "Fiery Inscription",
                            "type": "Enchantment",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/8/c/8c321159-43e5-40fc-9f0c-4ecc4f6cfd20.jpg?1686968925"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "ltr",
                    "isHorizontal": false,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "fed75268-c816-48fd-8eb4-d5a87396332e",
                "isHorizontal": false
            }
        ],
        "deckTopCardHiddenTo": {
            "ef32f23f-a797-435e-94a5-58e371317c64": true,
            "faa9bafc-3ce4-49e1-b19c-72054e5ff63b": true,
            "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6": true,
            "fed75268-c816-48fd-8eb4-d5a87396332e": true
        },
        "cardsLinks": [],
        "profileData": {
            "name": "PiouPiou",
            "avatar": "https://i.imgur.com/7QmYdYk.jpeg",
            "background": "https://i.imgur.com/G8ceHWa.jpeg"
        },
        "playerCounters": [
            {
                "id": "c537d252-274b-4565-8de5-bf811d68fe9e",
                "value": 40
            },
            {
                "id": "682c71a7-304a-4a74-aeed-54678cac2a83",
                "value": 0
            }
        ],
        "playerTokens": {},
        "playerNotes": "Player1: 0\nPlayer2: 0\nPlayer3: 0",
        "refreshCount": 3
    },
    "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6": {
        "visibleCards": [
            {
                "id": "ae83dec0-a263-4573-9e08-5af9c49041ea",
                "position": {
                    "section": "Hand",
                    "pos": {
                        "left": 602.5125,
                        "top": 507.75
                    },
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 0,
                    "reversedIndex": 4
                },
                "hiddenTo": {
                    "fed75268-c816-48fd-8eb4-d5a87396332e": true,
                    "ef32f23f-a797-435e-94a5-58e371317c64": true,
                    "faa9bafc-3ce4-49e1-b19c-72054e5ff63b": true
                },
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "e9b6a394-691c-425a-9307-76d8edc7375e",
                    "name": "Otawara, Soaring City",
                    "type": "Land",
                    "Card type": "Legendary Land",
                    "face": {
                        "front": {
                            "name": "Otawara, Soaring City",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/4/8/486d7edc-d983-41f0-8b78-c99aecd72996.jpg?1654568960"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "U"
                    ],
                    "set": "neo",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "c2c0c026-fbc0-48c9-94df-1ce5881ce805",
                "position": {
                    "section": "Discard",
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 0,
                    "reversedIndex": 9,
                    "pos": {
                        "left": 1515.65625,
                        "top": 360.703125
                    }
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "152b91c9-cc07-4ca8-944f-9bc2242a2283",
                    "name": "Whir of Invention",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Whir of Invention",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/0/2/0279fd3c-9252-4958-9d7a-5f33aa25907e.jpg?1576381590"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "aer",
                    "isHorizontal": false,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "6f4dd239-c01a-42dc-9db9-2b9258a5b168",
                "position": {
                    "section": "Discard",
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 6,
                    "reversedIndex": 3,
                    "pos": {
                        "left": 1515.65625,
                        "top": 360.703125
                    }
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "2167ac25-d042-4b48-b770-8b94acc1a965",
                    "name": "Chain of Vapor",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Chain of Vapor",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/3/8/38f741bf-13ee-4384-98ab-27833ebb9f6d.jpg?1562395835"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "c16",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "0465ddf4-68ce-49fa-936d-d40a049b35a6",
                "position": {
                    "section": "Discard",
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 7,
                    "reversedIndex": 2,
                    "pos": {
                        "left": 1515.65625,
                        "top": 360.703125
                    }
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "ecc435e2-deb1-420a-a79f-01dd08747314",
                    "name": "Pyroblast",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Pyroblast",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/b/0/b029eb9a-dd7a-40c2-96c4-0063d9cc002c.jpg?1580014621"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "ema",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "b8e837d4-c169-4230-8b5c-682ae674c9b3",
                "position": {
                    "section": "Mana",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 2,
                    "reversedIndex": 4,
                    "pos": {
                        "left": 242.61737499999998,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": true,
                "isFlipped": false,
                "cardData": {
                    "id": "b3e28bcf-0ed0-4406-b615-68ddc55b349a",
                    "name": "Great Hall of the Citadel",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Great Hall of the Citadel",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/2/1/219c7b57-b62b-42d1-85d9-4b57624a3f54.jpg?1686970335"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "ltr",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "b842b215-d200-4b84-a738-1b02649c2029",
                "position": {
                    "section": "Discard",
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 8,
                    "reversedIndex": 1,
                    "pos": {
                        "left": 1515.65625,
                        "top": 360.703125
                    }
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "a54f0869-94c8-42af-9080-166efb9486a4",
                    "name": "Gamble",
                    "type": "Sorcery",
                    "Card type": "Sorcery",
                    "face": {
                        "front": {
                            "name": "Gamble",
                            "type": "Sorcery",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/8/e/8e37fae5-ddd0-4e16-8581-71579f89d9c5.jpg?1745319947"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "dmr",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "84130a97-1643-4311-a24a-5924f4296486",
                "position": {
                    "section": "Other",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 4,
                    "reversedIndex": 5,
                    "pos": {
                        "left": 1244.7990138888888,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": null,
                "isFlipped": false,
                "cardData": {
                    "id": "6ad8011d-3471-4369-9d68-b264cc027487",
                    "name": "Sol Ring",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Sol Ring",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/7/b/7b0ccfd4-f118-4497-9c5a-54cf12000e16.jpg?1743206094"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "tdc",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "8569efba-521a-4ba6-8539-6424c1a013d7",
                "position": {
                    "section": "Commander",
                    "pos": {
                        "left": 75.359375,
                        "top": 4.59375
                    },
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 0,
                    "reversedIndex": 0
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "33666a98-812f-4892-9f8d-33e0cbecc340",
                    "name": "Niv-Mizzet, Parun",
                    "type": "Creature",
                    "Card type": "Legendary Creature — Dragon Wizard",
                    "face": {
                        "front": {
                            "name": "Niv-Mizzet, Parun",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/8/6/86c5c337-d25f-4c3e-9762-09ed0c2d36d7.jpg?1712354750"
                        }
                    },
                    "Colors": [
                        "R",
                        "U"
                    ],
                    "Color identity": [
                        "R",
                        "U"
                    ],
                    "set": "otc",
                    "isHorizontal": false,
                    "power": 5,
                    "toughness": 5,
                    "cost": 6
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "64ef92be-eb8f-47f3-a15c-5eaae35b36ae",
                "position": {
                    "section": "Mana",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 5,
                    "reversedIndex": 1,
                    "pos": {
                        "left": 493.504375,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": true,
                "isFlipped": false,
                "cardData": {
                    "id": "23467047-6dba-4498-b783-1ebc4f74b8c2",
                    "name": "Ancient Tomb",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Ancient Tomb",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/b/d/bd3d4b4b-cf31-4f89-8140-9650edb03c7b.jpg?1582753000"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "uma",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "2e1a28c1-3867-4394-9278-6770b46f8243",
                "position": {
                    "section": "Other",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 3,
                    "reversedIndex": 6,
                    "pos": {
                        "left": 1315.7271666666666,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": null,
                "isFlipped": false,
                "cardData": {
                    "id": "23216e59-f147-4bb7-a698-12777c2f8584",
                    "name": "Jeweled Lotus",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Jeweled Lotus",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/d/7/d7183700-6941-4a3d-a581-4f33bea795e9.jpg?1727093687"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "cmm",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "343a0fdd-d347-40fb-a6d8-671274962836",
                "position": {
                    "section": "Creatures",
                    "cardSize": {
                        "width": 14,
                        "height": 20
                    },
                    "index": 1,
                    "reversedIndex": 0,
                    "pos": {
                        "left": 912.671875,
                        "top": 4.59375
                    }
                },
                "hiddenTo": {},
                "isTapped": null,
                "isFlipped": false,
                "cardData": {
                    "id": "697bcfe1-ecbf-42a1-bfc7-0766d48ca56b",
                    "name": "Dockside Extortionist",
                    "type": "Creature",
                    "Card type": "Creature — Goblin Pirate",
                    "face": {
                        "front": {
                            "name": "Dockside Extortionist",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/9/e/9e2e3efb-75cb-430f-b9f4-cb58f3aeb91b.jpg?1727093692"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "2x2",
                    "isHorizontal": false,
                    "power": 1,
                    "toughness": 2,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "f57acef4-559b-4168-b9a0-abe4af93bd22",
                "position": {
                    "section": "Discard",
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 1,
                    "reversedIndex": 8,
                    "pos": {
                        "left": 1515.65625,
                        "top": 360.703125
                    }
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "48712d36-5c13-4ded-87a4-68106da4a5cd",
                    "name": "Mindbreak Trap",
                    "type": "Instant",
                    "Card type": "Instant — Trap",
                    "face": {
                        "front": {
                            "name": "Mindbreak Trap",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/4/f/4f51140b-6254-431a-8810-94307bfdfbbe.jpg?1562612097"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "zen",
                    "isHorizontal": false,
                    "cost": 4
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "af900a0c-86e9-46eb-80f4-257bd78f2bc2",
                "position": {
                    "section": "Mana",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 1,
                    "reversedIndex": 5,
                    "pos": {
                        "left": 158.988375,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": true,
                "isFlipped": false,
                "cardData": {
                    "id": "0fe16212-66c3-4e45-a641-7391e9b2e304",
                    "name": "Shivan Reef",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Shivan Reef",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/a/6/a67ddfae-746f-4952-8064-7d48f9f22981.jpg?1743207735"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "R",
                        "U"
                    ],
                    "set": "tdc",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "9bd7815b-4c87-4cda-8d0b-1b056a94bc79",
                "position": {
                    "section": "Other",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 2,
                    "reversedIndex": 7,
                    "pos": {
                        "left": 1386.6553194444443,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": null,
                "isFlipped": false,
                "cardData": {
                    "id": "f3c5978a-70fa-431f-933b-b954bd0db0ea",
                    "name": "Mox Diamond",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Mox Diamond",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/b/f/bf9fecfd-d122-422f-bd0a-5bf69b434dfe.jpg?1562431287"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "tpr",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "52ef5b4e-2565-475e-a621-4eb6414a4eff",
                "position": {
                    "section": "Discard",
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 5,
                    "reversedIndex": 4,
                    "pos": {
                        "left": 1515.65625,
                        "top": 360.703125
                    }
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "82506e51-3fe1-446f-83c9-69e67583cefc",
                    "name": "Slip Out the Back",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Slip Out the Back",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/d/9/d9d9fbbb-ed6c-45f7-a1d8-f9d29ae7930f.jpg?1706239838"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "clu",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "c0ec744c-7a6d-455e-8c7b-b99a191cade8",
                "position": {
                    "section": "Mana",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 0,
                    "reversedIndex": 6,
                    "pos": {
                        "left": 75.359375,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": true,
                "isFlipped": false,
                "cardData": {
                    "id": "cb027150-848c-4a66-88ad-e20222304dd8",
                    "name": "Scalding Tarn",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Scalding Tarn",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/7/1/71e491c5-8c07-449b-b2f1-ffa052e6d311.jpg?1738703652"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "mh2",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "12291835-648b-4804-aefb-aece654183d1",
                "position": {
                    "section": "Other",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 6,
                    "reversedIndex": 3,
                    "pos": {
                        "left": 1061.1282083333333,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": null,
                "isFlipped": false,
                "cardData": {
                    "id": "95560508-7ac9-4be9-8a3f-3c7d5b52807b",
                    "name": "Fellwar Stone",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Fellwar Stone",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/c/e/ce55e00c-cd95-48eb-986e-edf5125f3534.jpg?1743207310"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "tdc",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "12b5061e-09b7-4795-bb9e-fc78bc8c0dde",
                "position": {
                    "section": "Other",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 1,
                    "reversedIndex": 8,
                    "pos": {
                        "left": 1457.583472222222,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": null,
                "isFlipped": false,
                "cardData": {
                    "id": "8a52f3c0-2552-4425-b2e3-5496eb2232a7",
                    "name": "Mystic Remora",
                    "type": "Enchantment",
                    "Card type": "Enchantment",
                    "face": {
                        "front": {
                            "name": "Mystic Remora",
                            "type": "Enchantment",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/4/0/40140991-cffa-4b52-9a25-37e9a8aa9ddd.jpg?1675199366"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "dmr",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "e1987eb4-985a-4def-bec7-b00c256b2dc7",
                "position": {
                    "section": "Other",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 0,
                    "reversedIndex": 9,
                    "pos": {
                        "left": 1528.511625,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": null,
                "isFlipped": false,
                "cardData": {
                    "id": "13575cf9-65c1-4861-b21e-eb2155e07766",
                    "name": "Sensei's Divining Top",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Sensei's Divining Top",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/e/5/e5142b7a-e580-4737-a4aa-2590f6610ceb.jpg?1673149430"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "2x2",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "addb2bd1-a19d-4dd0-b129-47ad8fd25de7",
                "position": {
                    "section": "Creatures",
                    "cardSize": {
                        "width": 14,
                        "height": 20
                    },
                    "index": 0,
                    "reversedIndex": 1,
                    "pos": {
                        "left": 784.011875,
                        "top": 4.59375
                    }
                },
                "hiddenTo": {},
                "isTapped": null,
                "isFlipped": false,
                "cardData": {
                    "id": "e0aa6ce0-ca31-433b-ac6c-32b8675cdb71",
                    "name": "Spellskite",
                    "type": "Creature",
                    "Card type": "Artifact Creature — Phyrexian Horror",
                    "face": {
                        "front": {
                            "name": "Spellskite",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/7/2/72204934-f5aa-4559-8f7e-7b0b223580d0.jpg?1674142724"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "U"
                    ],
                    "set": "clb",
                    "isHorizontal": false,
                    "power": 0,
                    "toughness": 4,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "44ada86b-2915-4c76-9a71-46e356b8ee88",
                "position": {
                    "section": "Mana",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 3,
                    "reversedIndex": 3,
                    "pos": {
                        "left": 326.24637499999994,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": true,
                "isFlipped": false,
                "cardData": {
                    "id": "b2c6aa39-2d2a-459c-a555-fb48ba993373",
                    "name": "Island",
                    "type": "Land",
                    "Card type": "Basic Land — Island",
                    "face": {
                        "front": {
                            "name": "Island",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/1/f/1ff6acc9-581c-468f-894d-41f725da7f33.jpg?1743205101"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "U"
                    ],
                    "set": "tdm",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "637a5231-f379-4614-bb49-4e1c9a3d3ee5",
                "position": {
                    "section": "Mana",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 4,
                    "reversedIndex": 2,
                    "pos": {
                        "left": 409.87537499999996,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": true,
                "isFlipped": false,
                "cardData": {
                    "id": "b2c6aa39-2d2a-459c-a555-fb48ba993373",
                    "name": "Island",
                    "type": "Land",
                    "Card type": "Basic Land — Island",
                    "face": {
                        "front": {
                            "name": "Island",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/1/f/1ff6acc9-581c-468f-894d-41f725da7f33.jpg?1743205101"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "U"
                    ],
                    "set": "tdm",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "c62d9eac-d646-4aea-b08b-9f161d74e318",
                "position": {
                    "section": "Discard",
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 4,
                    "reversedIndex": 5,
                    "pos": {
                        "left": 1515.65625,
                        "top": 360.703125
                    }
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "0826cf7d-7ccc-459b-a92f-29dc169628f8",
                    "name": "Muddle the Mixture",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Muddle the Mixture",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/e/6/e69d760c-48fb-4e7f-8611-547b0c22928c.jpg?1702429399"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "rvr",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "d266cde3-8e9f-4dbf-9acb-e18a66ccf695",
                "position": {
                    "section": "Discard",
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 3,
                    "reversedIndex": 6,
                    "pos": {
                        "left": 1515.65625,
                        "top": 360.703125
                    }
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "956381ba-6d37-4a8a-846c-bad79222dbee",
                    "name": "Force of Will",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Force of Will",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/8/9/89f612d6-7c59-4a7b-a87d-45f789e88ba5.jpg?1675199280"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "dmr",
                    "isHorizontal": false,
                    "cost": 5
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "960d6af6-37a0-4bdd-b57f-bcf81d5ab9cb",
                "position": {
                    "section": "Discard",
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 2,
                    "reversedIndex": 7,
                    "pos": {
                        "left": 1515.65625,
                        "top": 360.703125
                    }
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "ac2173f9-f223-440a-9231-fd98762bdc6f",
                    "name": "Force of Negation",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Force of Negation",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/1/8/1825a719-1b2a-4af9-9cd2-7cb497cd0317.jpg?1673147298"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "2x2",
                    "isHorizontal": false,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "0379b193-4d3b-42ec-83a1-adfac70a9311",
                "position": {
                    "section": "Other",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 5,
                    "reversedIndex": 4,
                    "pos": {
                        "left": 1132.056361111111,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": null,
                "isFlipped": false,
                "cardData": {
                    "id": "4c6a0c30-b547-4eff-8ff4-0ca25803c076",
                    "name": "Urza's Saga",
                    "type": "Enchantment",
                    "Card type": "Enchantment Land — Urza's Saga",
                    "face": {
                        "front": {
                            "name": "Urza's Saga",
                            "type": "Enchantment",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/c/1/c1e0f201-42cb-46a1-901a-65bb4fc18f6c.jpg?1667318301"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "mh2",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false,
                "isSpun": null,
                "grouppedCards": [
                    {
                        "id": "e63a5bea-6e4c-4c1e-a32a-663026809acf",
                        "position": {
                            "section": false,
                            "cardSize": {
                                "width": 9.1,
                                "height": 13
                            },
                            "pos": {
                                "left": 1173.870861111111,
                                "top": 685.10325
                            },
                            "index": -5
                        },
                        "hiddenTo": {},
                        "isTapped": false,
                        "isFlipped": false,
                        "cardData": {
                            "id": "223fa044-d387-4884-bf4e-75f1b61c6a46",
                            "name": "Curiosity",
                            "type": "Enchantment - Aura",
                            "Card type": "Enchantment — Aura",
                            "face": {
                                "front": {
                                    "name": "Curiosity",
                                    "type": "Enchantment - Aura",
                                    "cost": 0,
                                    "isHorizontal": false,
                                    "image": "https://cards.scryfall.io/normal/front/c/5/c5a0be10-c20f-4ac0-89a5-1770ecf48aad.jpg?1600697752"
                                }
                            },
                            "Colors": [
                                "U"
                            ],
                            "Color identity": [
                                "U"
                            ],
                            "set": "jmp",
                            "isHorizontal": false,
                            "cost": 1
                        },
                        "counters": [
                            {},
                            {}
                        ],
                        "notes": "",
                        "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                        "isHorizontal": false,
                        "grouppedToId": "0379b193-4d3b-42ec-83a1-adfac70a9311"
                    }
                ]
            },
            {
                "id": "873ec7ad-d4e5-42f8-be99-5f8502415ff8",
                "position": {
                    "section": "Mana",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 6,
                    "reversedIndex": 0,
                    "pos": {
                        "left": 577.133375,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": true,
                "isFlipped": false,
                "cardData": {
                    "id": "6587a463-a108-4854-b6d1-944e89b8c8a4",
                    "name": "Wooded Foothills",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Wooded Foothills",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/4/e/4e11ea8a-f895-438d-a3b7-f070238e4161.jpg?1717013111"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "mh3",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "e63a5bea-6e4c-4c1e-a32a-663026809acf",
                "position": {
                    "section": false,
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "pos": {
                        "left": 1173.870861111111,
                        "top": 209.525125
                    },
                    "index": -5
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "223fa044-d387-4884-bf4e-75f1b61c6a46",
                    "name": "Curiosity",
                    "type": "Enchantment - Aura",
                    "Card type": "Enchantment — Aura",
                    "face": {
                        "front": {
                            "name": "Curiosity",
                            "type": "Enchantment - Aura",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/c/5/c5a0be10-c20f-4ac0-89a5-1770ecf48aad.jpg?1600697752"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "jmp",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false,
                "grouppedToId": "0379b193-4d3b-42ec-83a1-adfac70a9311"
            },
            {
                "id": "4d7c0890-c335-40de-b51b-3ef13378a0a2",
                "position": {
                    "section": "Other",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 8,
                    "reversedIndex": 1,
                    "pos": {
                        "left": 919.2719027777777,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": null,
                "isFlipped": false,
                "cardData": {
                    "id": "3aa83ed2-f48b-4ce6-a614-2c54ddf50538",
                    "name": "The One Ring",
                    "type": "Artifact",
                    "Card type": "Legendary Artifact",
                    "face": {
                        "front": {
                            "name": "The One Ring",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/d/5/d5806e68-1054-458e-866d-1f2470f682b2.jpg?1734350327"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "ltr",
                    "isHorizontal": false,
                    "cost": 4
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "0e800499-bf07-4f17-a3f7-ccc1aff1fe91",
                "position": {
                    "section": "Other",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 7,
                    "reversedIndex": 2,
                    "pos": {
                        "left": 990.2000555555554,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": true,
                "isFlipped": false,
                "cardData": {
                    "id": "0bc7f093-bef0-4f1a-852c-4b75ebf54838",
                    "name": "Arcane Signet",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Arcane Signet",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/9/3/935644d4-a140-4f24-b8ab-d5e79a682a9b.jpg?1743206090"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "tdc",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "a9244bad-780e-4692-bb6d-3d100119cdd3",
                "position": {
                    "section": "Hand",
                    "pos": {
                        "left": 699.0074999999999,
                        "top": 507.75
                    },
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 1,
                    "reversedIndex": 3
                },
                "hiddenTo": {
                    "fed75268-c816-48fd-8eb4-d5a87396332e": true,
                    "ef32f23f-a797-435e-94a5-58e371317c64": true,
                    "faa9bafc-3ce4-49e1-b19c-72054e5ff63b": true
                },
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "f3e213a4-ba5a-468a-93b3-c0a34e1bd725",
                    "name": "Pact of Negation",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Pact of Negation",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/1/e/1ed4c0bb-b710-44a1-b8bc-6bd11c27b8b8.jpg?1697121218"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "tsr",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "56811008-ef52-4c9a-894f-053cfafa133c",
                "position": {
                    "section": "Hand",
                    "pos": {
                        "left": 795.5025,
                        "top": 507.75
                    },
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 2,
                    "reversedIndex": 2
                },
                "hiddenTo": {
                    "fed75268-c816-48fd-8eb4-d5a87396332e": true,
                    "ef32f23f-a797-435e-94a5-58e371317c64": true,
                    "faa9bafc-3ce4-49e1-b19c-72054e5ff63b": true
                },
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "02090581-61aa-4348-ad57-451be8ee91c2",
                    "name": "Ponder",
                    "type": "Sorcery",
                    "Card type": "Sorcery",
                    "face": {
                        "front": {
                            "name": "Ponder",
                            "type": "Sorcery",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/d/c/dc69f960-68ba-4315-8146-6a7a82047503.jpg?1743206358"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "tdc",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "aa9e2263-53c0-4baa-9d41-0ca097883447",
                "position": {
                    "section": "Discard",
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 9,
                    "reversedIndex": 0,
                    "pos": {
                        "left": 1515.65625,
                        "top": 360.703125
                    }
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "1a0770e6-b093-4439-baff-6889a50ba12e",
                    "name": "Mental Misstep",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Mental Misstep",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/6/1/61e9c6df-1c84-4eab-9076-a4feb6347c10.jpg?1566819829"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "nph",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "d50b816f-5fc6-45e3-a28e-1f66b997429f",
                "position": {
                    "section": "Hand",
                    "pos": {
                        "left": 891.9975,
                        "top": 507.75
                    },
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 3,
                    "reversedIndex": 1
                },
                "hiddenTo": {
                    "fed75268-c816-48fd-8eb4-d5a87396332e": true,
                    "ef32f23f-a797-435e-94a5-58e371317c64": true,
                    "faa9bafc-3ce4-49e1-b19c-72054e5ff63b": true
                },
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "753cb2b2-24ce-484f-a2d0-be6fd2c67ebd",
                    "name": "Grafdigger's Cage",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Grafdigger's Cage",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/0/a/0a135e09-b534-4836-9a10-3a9a4a9f8c53.jpg?1592517646"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "m20",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "87348887-1699-4c88-b5c1-6b0037424c2d",
                "position": {
                    "section": "Other",
                    "cardSize": {
                        "width": 9.1,
                        "height": 13
                    },
                    "index": 9,
                    "reversedIndex": 0,
                    "pos": {
                        "left": 848.3437499999998,
                        "top": 197.578125
                    }
                },
                "hiddenTo": {},
                "isTapped": null,
                "isFlipped": false,
                "cardData": {
                    "id": "2c63e4e1-89d2-4bc6-a232-94e75c4b1c8a",
                    "name": "Mana Crypt",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Mana Crypt",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/4/d/4d960186-4559-4af0-bd22-63baa15f8939.jpg?1727298349"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "2xm",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false,
                "isSpun": null
            },
            {
                "id": "7f7d6d30-77cb-441b-9d1e-ec1b307091d0",
                "position": {
                    "section": "Hand",
                    "pos": {
                        "left": 988.4925,
                        "top": 507.75
                    },
                    "cardSize": {
                        "width": 10.5,
                        "height": 15
                    },
                    "index": 4,
                    "reversedIndex": 0
                },
                "hiddenTo": {
                    "fed75268-c816-48fd-8eb4-d5a87396332e": true,
                    "ef32f23f-a797-435e-94a5-58e371317c64": true,
                    "faa9bafc-3ce4-49e1-b19c-72054e5ff63b": true
                },
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "c5acf2a5-40f4-433d-a74d-1cb56c521464",
                    "name": "Arid Mesa",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Arid Mesa",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/2/5/25ac5405-df7b-4097-914a-022cb18e20d4.jpg?1738703645"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "mh2",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            }
        ],
        "deck": [
            {
                "id": "99e9a75e-e57b-4d41-b17c-1ff5912681f1",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "ae120613-97d6-4393-b39d-c3e6c076f5d6",
                    "name": "Deflecting Swat",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Deflecting Swat",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/b/4/b4b36435-55b3-4615-8812-af41d4fc64d9.jpg?1745319946"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "cmm",
                    "isHorizontal": false,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "a76308e5-8d1e-4e91-9923-4b7ecebb3205",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "fc0707c7-d504-4ccf-a0d2-3eb6e26e7a57",
                    "name": "Bloodstained Mire",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Bloodstained Mire",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/5/7/579743fe-f71e-4cb2-8629-d6b02ed1591d.jpg?1717012950"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "mh3",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "1fa7e3f6-bd22-451e-97da-872138a68702",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "2c0a0a7d-b12f-47c8-a6a6-d046f999ec6b",
                    "name": "Yusri, Fortune's Flame",
                    "type": "Creature",
                    "Card type": "Legendary Creature — Efreet",
                    "face": {
                        "front": {
                            "name": "Yusri, Fortune's Flame",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/b/f/bfab9e33-0d07-46e6-be06-1eaffe26cbfd.jpg?1626098876"
                        }
                    },
                    "Colors": [
                        "R",
                        "U"
                    ],
                    "Color identity": [
                        "R",
                        "U"
                    ],
                    "set": "mh2",
                    "isHorizontal": false,
                    "power": 2,
                    "toughness": 3,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "dfd0710e-6970-49be-8a53-1bab2173c7b7",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "e83b8830-fa97-4e60-b042-005e552a3ceb",
                    "name": "Ophidian Eye",
                    "type": "Enchantment - Aura",
                    "Card type": "Enchantment — Aura",
                    "face": {
                        "front": {
                            "name": "Ophidian Eye",
                            "type": "Enchantment - Aura",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/2/6/26836ff5-b3c3-4b10-af1e-df3658781cb2.jpg?1562903093"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "tsp",
                    "isHorizontal": false,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "425517bc-8aa9-4304-a5ca-81b8f615835b",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "032b8a0d-491a-4a12-ab9f-689010054d5b",
                    "name": "Prismatic Vista",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Prismatic Vista",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/e/3/e37da81e-be12-45a2-9128-376f1ad7b3e8.jpg?1562202585"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "mh1",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "292a3ed6-1fb6-4573-8fc3-5642215416e4",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "b2c6aa39-2d2a-459c-a555-fb48ba993373",
                    "name": "Island",
                    "type": "Land",
                    "Card type": "Basic Land — Island",
                    "face": {
                        "front": {
                            "name": "Island",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/1/f/1ff6acc9-581c-468f-894d-41f725da7f33.jpg?1743205101"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "U"
                    ],
                    "set": "tdm",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "69765e9c-1cb1-492d-bbf3-ba693f52669f",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "bde94af8-faea-41ff-8eed-ba642eac9968",
                    "name": "Phantasmal Image",
                    "type": "Creature",
                    "Card type": "Creature — Illusion",
                    "face": {
                        "front": {
                            "name": "Phantasmal Image",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/c/1/c1c080cf-a5e8-4d9d-af49-f78588971e87.jpg?1631586379"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "afc",
                    "isHorizontal": false,
                    "power": 0,
                    "toughness": 0,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "bbcd151b-0423-4e6c-902d-77f6f6def3c0",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "a9a84fbb-0972-4a3d-bdae-a3b01219b35d",
                    "name": "Thada Adel, Acquisitor",
                    "type": "Creature",
                    "Card type": "Legendary Creature — Merfolk Rogue",
                    "face": {
                        "front": {
                            "name": "Thada Adel, Acquisitor",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/3/b/3bfcbeab-7a1e-4dcf-99bf-98f42c2b6a6f.jpg?1562285424"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "wwk",
                    "isHorizontal": false,
                    "power": 2,
                    "toughness": 2,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "23269e83-1090-4347-9d32-c0439908592c",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "ab1cc360-b9de-48d9-9983-4dfe4a7d2a37",
                    "name": "Arcane Denial",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Arcane Denial",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/9/b/9b3f47a9-65fb-4b53-8e52-1c4b678b5841.jpg?1726284627"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "dsc",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "b48e757a-bf77-4fc4-bfc1-ad9eae8c35d0",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "cfd60d1f-9832-4408-b84e-0fd3018b015b",
                    "name": "Forbidden Orchard",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Forbidden Orchard",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/1/7/17db644c-1acf-477d-9c20-f72221f1108a.jpg?1673149497"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "2x2",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "65ae4272-ce07-4cd2-909c-8be70cbf4a1b",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "e3570ac7-c593-40e3-bbd6-ec3da6d8158d",
                    "name": "Training Center",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Training Center",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/7/8/78a39d22-5e3b-4ba0-b728-dbf16b61fc8f.jpg?1690000040"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "R",
                        "U"
                    ],
                    "set": "cmm",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "3835f2ab-bbf9-439b-998b-939b0d41e6ae",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "a3fb7228-e76b-4e96-a40e-20b5fed75685",
                    "name": "Mountain",
                    "type": "Land",
                    "Card type": "Basic Land — Mountain",
                    "face": {
                        "front": {
                            "name": "Mountain",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/b/f/bfa10a88-12e0-4b79-80bb-6f4620277e20.jpg?1743205117"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "R"
                    ],
                    "set": "tdm",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "c3f1ef3a-2d3b-48bf-8f0f-1785e160fcd7",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "27b047e3-0d41-45e2-98e9-9391d7923a1e",
                    "name": "Exotic Orchard",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Exotic Orchard",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/c/2/c2ea2395-4518-4683-8eed-59c43fb3328a.jpg?1743207546"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "tdc",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "be9f1165-da29-467b-8fb0-a7faf7c34223",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "bb329a5c-b9f9-4973-a53f-090024146325",
                    "name": "Red Elemental Blast",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Red Elemental Blast",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/7/0/70a45e9b-699e-425a-9f3d-267274830d3e.jpg?1562436618"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "a25",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "997c94ab-d400-41c1-ab47-5ee3fcd7b3d2",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "46eefc72-2d9e-4389-8ae1-26d9ee472b5c",
                    "name": "Tolaria West",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Tolaria West",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/b/0/b005eef6-75f3-454f-a42b-d851bc84ac4e.jpg?1619399546"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "U"
                    ],
                    "set": "tsr",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "1b005e90-30ec-4b1f-a3d3-86247f3a619e",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "09dd85aa-47bc-4713-a9b9-8b52ff2285ed",
                    "name": "Misty Rainforest",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Misty Rainforest",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/8/8/88231c0d-0cc8-44ec-bf95-81d1710ac141.jpg?1738703648"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "mh2",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "1e7a95f1-d2f9-4e1e-8b48-f1ee94d48606",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "1576f031-57ca-4894-b461-8ea57b6cefdc",
                    "name": "Tandem Lookout",
                    "type": "Creature",
                    "Card type": "Creature — Human Scout",
                    "face": {
                        "front": {
                            "name": "Tandem Lookout",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/3/e/3e44b411-ccb8-44c8-a021-2372c945f0d3.jpg?1593813158"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "mm3",
                    "isHorizontal": false,
                    "power": 2,
                    "toughness": 1,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "61fc7ade-2ec0-4e0f-95e2-67bb7beb4bc9",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "14d2979d-5728-42d7-a027-0eb1f754655d",
                    "name": "Talisman of Creativity",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Talisman of Creativity",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/b/f/bfe00640-e775-4b2e-91a8-081c7ec0125c.jpg?1743207377"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "R",
                        "U"
                    ],
                    "set": "tdc",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "54cb1e9e-0ac0-4902-be0e-6e2ac1a1a270",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "c0adbddc-b070-4c5f-afe0-0474c72a9251",
                    "name": "Gemstone Caverns",
                    "type": "Land",
                    "Card type": "Legendary Land",
                    "face": {
                        "front": {
                            "name": "Gemstone Caverns",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/7/f/7f273641-c5f3-48bc-b89e-3cff52d26a0b.jpg?1619399338"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "tsr",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "81471271-40f7-46ad-9656-472b2a94c9f0",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "f3c7af78-a77d-4134-82a2-a5ce84285a84",
                    "name": "Flooded Strand",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Flooded Strand",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/8/f/8f85e12c-196b-4459-b81f-0c9c854e9f57.jpg?1717012985"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "mh3",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "3e7375b7-c2ac-4b18-a881-a8fa9c14cc3a",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "0895c9b7-ae7d-4bb3-af17-3b75deb50a25",
                    "name": "Command Tower",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Command Tower",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/5/f/5fc770b6-03ac-45c3-a2ca-bd508096384e.jpg?1743206097"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "tdc",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "0761a85c-d06b-4865-975f-bc4010b5df93",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "32e5339e-9e4f-46f8-b305-f9d6d3ba8bb5",
                    "name": "Lotus Petal",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Lotus Petal",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/f/8/f85ab5f9-508e-45de-8fa1-ce1f16552ffc.jpg?1701537448"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "tpr",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "fbb3eaa4-9457-4bed-98e6-68a01a7ad8cb",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "f8b17b89-26ce-4208-874a-9e1d66514640",
                    "name": "Dig Through Time",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Dig Through Time",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/5/7/572b3180-9822-4885-b81c-b1bf8aca5a5e.jpg?1726284660"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "dsc",
                    "isHorizontal": false,
                    "cost": 8
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "32b2190f-a1e7-4e91-901a-138cba896163",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "37108cd4-bbab-4ce3-9ed6-f60e8422e703",
                    "name": "Ragavan, Nimble Pilferer",
                    "type": "Creature",
                    "Card type": "Legendary Creature — Monkey Pirate",
                    "face": {
                        "front": {
                            "name": "Ragavan, Nimble Pilferer",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/a/9/a9738cda-adb1-47fb-9f4c-ecd930228c4d.jpg?1681963138"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "mh2",
                    "isHorizontal": false,
                    "power": 2,
                    "toughness": 1,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "95740e18-32d5-4aa8-8860-1d8aed9439d2",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "ac641490-ca14-48d7-8cc4-b69ce984befa",
                    "name": "Preordain",
                    "type": "Sorcery",
                    "Card type": "Sorcery",
                    "face": {
                        "front": {
                            "name": "Preordain",
                            "type": "Sorcery",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/d/d/dd29a0e5-c1de-4e8a-8866-715e9f9cde1f.jpg?1743206370"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "tdc",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "a3bdbda4-ec62-4e05-913c-26b4e8095eb1",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "ef86989d-ce80-4e55-aece-7d11710eeffa",
                    "name": "Polluted Delta",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Polluted Delta",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/6/e/6e288374-2b71-4ace-b1d2-a19fee6cb4af.jpg?1717013017"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "mh3",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "98f96046-5486-4862-94f4-3b8af7e3f2c4",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "b2c6aa39-2d2a-459c-a555-fb48ba993373",
                    "name": "Island",
                    "type": "Land",
                    "Card type": "Basic Land — Island",
                    "face": {
                        "front": {
                            "name": "Island",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/1/f/1ff6acc9-581c-468f-894d-41f725da7f33.jpg?1743205101"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "U"
                    ],
                    "set": "tdm",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "5a5bc591-1f35-4e16-ad43-7e6884b14b3a",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "53236dd7-845a-444c-96d5-f41ed7325d8f",
                    "name": "Rhystic Study",
                    "type": "Enchantment",
                    "Card type": "Enchantment",
                    "face": {
                        "front": {
                            "name": "Rhystic Study",
                            "type": "Enchantment",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/d/6/d6914dba-0d27-4055-ac34-b3ebf5802221.jpg?1600698439"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "jmp",
                    "isHorizontal": false,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "058680e5-54d9-4e7a-81ac-8ac052429309",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "7f06c098-6482-4bf3-a9a1-110d6d5b5703",
                    "name": "Gilded Drake",
                    "type": "Creature",
                    "Card type": "Creature — Drake",
                    "face": {
                        "front": {
                            "name": "Gilded Drake",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/8/d/8de3fdae-cc2c-4a14-b15b-4fe1a983dfbf.jpg?1562924943"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "usg",
                    "isHorizontal": false,
                    "power": 3,
                    "toughness": 3,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "08064cb0-ac63-4290-8f23-e6e5411a2047",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "de2440de-e948-4811-903c-0bbe376ff64d",
                    "name": "Mox Opal",
                    "type": "Artifact",
                    "Card type": "Legendary Artifact",
                    "face": {
                        "front": {
                            "name": "Mox Opal",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/5/6/56001a36-126b-4c08-af98-a6cc4d84210e.jpg?1734350253"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "2xm",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "a00c2e13-2eb0-4271-9eb9-ec2e08504f97",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "14d5ed90-0aa7-48f0-9017-83912b9e89d1",
                    "name": "Geistwave",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Geistwave",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/f/0/f0e3d1ac-bec2-4bba-a6cf-a823996dde2d.jpg?1634348915"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "mid",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "7ea07952-4d04-4e04-9ef2-dd80638f4300",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "2fda4fe7-8b0c-489c-a000-6d358e614e34",
                    "name": "Izzet Signet",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Izzet Signet",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/2/c/2c747a97-9070-4c1e-b7b7-52637fbb30e1.jpg?1743207322"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "R",
                        "U"
                    ],
                    "set": "tdc",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "d2313d2f-f342-469c-9791-84746790fdb1",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "74d3277a-38e5-4732-afed-084a56148f20",
                    "name": "Mana Drain",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Mana Drain",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/3/c/3c429c40-2389-41e5-8681-4bb274e25eba.jpg?1737917379"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "2x2",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "11a54a82-069b-4640-b880-ffd7a46dc6e2",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "f25351e3-539b-4bbc-b92d-6480acf4d722",
                    "name": "City of Brass",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "City of Brass",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/b/e/bed4a63d-632a-4a3a-b35f-f8e155237d27.jpg?1673149483"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "2x2",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "54142998-b1f8-410c-8914-f1dc941618de",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "ac914d98-221e-426c-8a50-342896b15f9e",
                    "name": "Snap",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Snap",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/f/1/f13406c6-f208-402a-94d3-a94a24f03563.jpg?1675199430"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "dmr",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "91666af8-7ef1-4598-85a7-f56f7dc27c03",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "234a734b-ba28-4f1b-9d01-3c3e7d516590",
                    "name": "An Offer You Can't Refuse",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "An Offer You Can't Refuse",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/a/8/a829747f-cf9b-4d81-ba66-9f0630ed4565.jpg?1730489199"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "fdn",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "606a2e7f-c060-4978-a523-ad6fb956060d",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "16e015b2-f8a3-4b1a-80be-58a8f5fb5e8c",
                    "name": "Frantic Search",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Frantic Search",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/a/1/a1c71f3e-16be-492a-8a3e-5911867270bd.jpg?1743206320"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "tdc",
                    "isHorizontal": false,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "d0c2d647-6fe2-4c22-abc9-373b617e7622",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "16d8ee99-8ec8-429f-9ba7-818a74b6f910",
                    "name": "Gush",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Gush",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/d/4/d4a3a921-3b7f-474c-b8c3-67a1a6ba5cc1.jpg?1562378488"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "jvc",
                    "isHorizontal": false,
                    "cost": 5
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "ac3f72d7-9b4b-40dc-8fbb-fa00e4d319fc",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "70486bee-6ee7-41ea-b834-8caf4699302b",
                    "name": "Daze",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Daze",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/f/0/f05e9a3e-8a35-4687-85cb-e31b3927a5e2.jpg?1580013916"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "ema",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "74457cdb-1918-4549-9da4-95c0f961f6ac",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "4c9bcba6-87b5-4fb3-97ee-6fe5b739337d",
                    "name": "Consider",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Consider",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/f/f/ff6f3824-3670-46e1-af43-0db405726084.jpg?1743206296"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "tdc",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "ea6ea392-0f95-4484-808d-058c83ee9f8e",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "44e0ffa3-8915-4c1f-8f1a-4aeea1365f07",
                    "name": "Simian Spirit Guide",
                    "type": "Creature",
                    "Card type": "Creature — Ape Spirit",
                    "face": {
                        "front": {
                            "name": "Simian Spirit Guide",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/0/e/0e57335d-4066-4d73-83cd-67a215e01a4e.jpg?1619397622"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "tsr",
                    "isHorizontal": false,
                    "power": 2,
                    "toughness": 2,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "acb72b6a-3a44-407b-bd6e-7348a7d3b3cd",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "d09c9cba-fdd2-479b-ad5d-d05181c3e3f9",
                    "name": "Fierce Guardianship",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Fierce Guardianship",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/f/7/f7f3dd95-bd14-4e0f-a388-444f9cf1b0dc.jpg?1689996370"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "cmm",
                    "isHorizontal": false,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "fa18c5c0-8dee-4ea0-9181-c017220e061b",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "05849bd6-8f38-4031-be2b-e2aa03beb8cc",
                    "name": "Pongify",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Pongify",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/4/1/4131fa63-5afc-4b63-a4b4-f47b4bced87f.jpg?1743206367"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "tdc",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "2972e4ca-b9c6-446a-bb9d-c74a0f8ed1a9",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "088dfd02-c0e0-41d1-9923-efe023fb2ad1",
                    "name": "Counterbalance",
                    "type": "Enchantment",
                    "Card type": "Enchantment",
                    "face": {
                        "front": {
                            "name": "Counterbalance",
                            "type": "Enchantment",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/c/3/c329ff2b-0331-4934-a8df-870dd7bf402b.jpg?1593274911"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "csp",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "6913a2f5-6655-4bae-a28b-e55bb3960bd4",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "c718911c-c955-4eb9-9e16-be4bd49a4e4e",
                    "name": "Volcanic Island",
                    "type": "Land",
                    "Card type": "Land — Island Mountain",
                    "face": {
                        "front": {
                            "name": "Volcanic Island",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/2/f/2f607e7e-30c0-45e9-8f61-bf6e9fe63f2b.jpg?1562904669"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "R",
                        "U"
                    ],
                    "set": "vma",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "4eae5777-a996-41f5-b601-c5959d45b68c",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "99427ebe-c00d-4206-84ca-9764f6e952c6",
                    "name": "Submerge",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Submerge",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/d/2/d2741fe4-37fe-427f-ae85-5107991d4eee.jpg?1562632167"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "nem",
                    "isHorizontal": false,
                    "cost": 5
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "a0dacec9-6526-441a-9afa-de5333fbc2e0",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "4d6a1391-817a-4ddc-840d-886b138eeb3f",
                    "name": "Imperial Recruiter",
                    "type": "Creature",
                    "Card type": "Creature — Human Advisor",
                    "face": {
                        "front": {
                            "name": "Imperial Recruiter",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/0/5/05bd329b-5707-42fc-af1c-084cc604e805.jpg?1626100528"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "mh2",
                    "isHorizontal": false,
                    "power": 1,
                    "toughness": 1,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "cd2a29a0-c197-4644-bf6b-269bb0eb1668",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "ec3d4466-547c-4e02-b1b5-a156ec4637e9",
                    "name": "Chrome Mox",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Chrome Mox",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/f/3/f340cbf7-5bbe-45b9-a4bf-d1caa500ff93.jpg?1739403657"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "2xm",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "826327f9-f9ee-4a16-8d80-587d69ea3683",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "06692cd9-ac2f-4a32-8fd1-043ba3c0fe71",
                    "name": "Rapid Hybridization",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Rapid Hybridization",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/b/6/b6912638-b087-4754-9e7e-8bd76fbf095c.jpg?1743206378"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "tdc",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "039b8d46-9710-40e9-a778-f802cb2de8c7",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "72e8d67a-41e6-4074-bcbd-b54ead995237",
                    "name": "Pentad Prism",
                    "type": "Artifact",
                    "Card type": "Artifact",
                    "face": {
                        "front": {
                            "name": "Pentad Prism",
                            "type": "Artifact",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/2/a/2a2862c5-afa8-4e38-a312-483300f8b194.jpg?1599709726"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "2xm",
                    "isHorizontal": false,
                    "cost": 2
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "29e18a9c-8779-4a48-b43c-804deb369dac",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "c39e5fb0-6de3-4105-ad3c-0ecb8951a1d5",
                    "name": "Misdirection",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Misdirection",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/c/9/c96763d6-0cea-40ed-afb2-886bfebe50a0.jpg?1592764638"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "ddt",
                    "isHorizontal": false,
                    "cost": 5
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "dadfe1ba-872d-4b33-a375-44ed653dbf99",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "8ddfc283-c9b4-41a5-af88-cf0068e986cc",
                    "name": "Swan Song",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Swan Song",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/9/d/9d968dde-c406-48ef-a1ab-373aebc24693.jpg?1562412350"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "c16",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "568ae548-6631-4b6b-8b5f-69c5251b0f1c",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "02f5ceb4-8b9c-4107-972b-6eec365c4a6c",
                    "name": "Thunderclap",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Thunderclap",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/b/3/b3f8c5ee-2179-4c05-adc9-0b66d02b59ad.jpg?1562382554"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "mmq",
                    "isHorizontal": false,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "04379fc2-9fc7-4e80-b81d-cfd38b0571ef",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "826d4279-1576-4898-a1c2-26fd547fb0d0",
                    "name": "Treasonous Ogre",
                    "type": "Creature",
                    "Card type": "Creature — Ogre Shaman",
                    "face": {
                        "front": {
                            "name": "Treasonous Ogre",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/a/e/ae48c31d-6fd9-457f-adb8-37f367724ba1.jpg?1562866402"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "cns",
                    "isHorizontal": false,
                    "power": 2,
                    "toughness": 3,
                    "cost": 4
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "683f2be7-b729-4b18-8113-15b990630252",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "86bf58f2-7f25-4e10-b797-25e0e8e67769",
                    "name": "Flusterstorm",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Flusterstorm",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/f/9/f900eeb7-7c45-44bc-ad3a-0bbe594ecf50.jpg?1562856071"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "ima",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "b46d7711-c3bf-47b1-b201-34429c649069",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "026f4a4b-eedd-44e1-9d37-ca4fb8d6db98",
                    "name": "Fiery Islet",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Fiery Islet",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/a/3/a3aab13c-9d9d-4507-ae5d-da979990ae1b.jpg?1562202552"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "R",
                        "U"
                    ],
                    "set": "mh1",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "70afe0eb-c9ff-4c26-a70b-176443393cf6",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "17039058-822d-409f-938c-b727a366ba63",
                    "name": "Steam Vents",
                    "type": "Land",
                    "Card type": "Land — Island Mountain",
                    "face": {
                        "front": {
                            "name": "Steam Vents",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/6/6/66d618f4-443c-4a6c-8cbd-5d4ea96b2cd4.jpg?1702429824"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "R",
                        "U"
                    ],
                    "set": "rvr",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "f36e4fd2-9e64-4a21-85d4-8d4bdc1441c4",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "36cd2364-d113-47d1-b2c4-b088d9eb88dd",
                    "name": "Brainstorm",
                    "type": "Instant",
                    "Card type": "Instant",
                    "face": {
                        "front": {
                            "name": "Brainstorm",
                            "type": "Instant",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/8/b/8beb987c-1b67-4a4e-ae71-58547afad2a0.jpg?1726284649"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "dsc",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "01974eee-327f-48a3-bfd3-834e5b610bc3",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "b2c6aa39-2d2a-459c-a555-fb48ba993373",
                    "name": "Island",
                    "type": "Land",
                    "Card type": "Basic Land — Island",
                    "face": {
                        "front": {
                            "name": "Island",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/1/f/1ff6acc9-581c-468f-894d-41f725da7f33.jpg?1743205101"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "U"
                    ],
                    "set": "tdm",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "3ad50a2b-389a-4291-badc-d7803e4bd3cb",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "b2c6aa39-2d2a-459c-a555-fb48ba993373",
                    "name": "Island",
                    "type": "Land",
                    "Card type": "Basic Land — Island",
                    "face": {
                        "front": {
                            "name": "Island",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/1/f/1ff6acc9-581c-468f-894d-41f725da7f33.jpg?1743205101"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "U"
                    ],
                    "set": "tdm",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "a66afde1-79a8-4222-86a9-c255f7063de3",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "d0ee5bdc-2b69-4b73-9a20-ffcc18783b29",
                    "name": "Mana Confluence",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Mana Confluence",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/5/0/504a69eb-3c2d-4bb1-b117-252b15acf0c2.jpg?1593096534"
                        }
                    },
                    "Colors": [],
                    "Color identity": [],
                    "set": "jou",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "d160fc6a-41ff-401e-9b33-2210334201bf",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "145737a7-c597-4dec-b752-207c2d0501e3",
                    "name": "Goblin Matron",
                    "type": "Creature",
                    "Card type": "Creature — Goblin",
                    "face": {
                        "front": {
                            "name": "Goblin Matron",
                            "type": "Creature",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/a/5/a521a254-c484-4d59-bb7e-8745e96d4bbf.jpg?1675200004"
                        }
                    },
                    "Colors": [
                        "R"
                    ],
                    "Color identity": [
                        "R"
                    ],
                    "set": "dmr",
                    "isHorizontal": false,
                    "power": 1,
                    "toughness": 1,
                    "cost": 3
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "87925ac3-3dd4-4388-9386-7dbc9ba8116e",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "1d67f5ff-1fce-45e5-b6a1-416c569351e2",
                    "name": "Gitaxian Probe",
                    "type": "Sorcery",
                    "Card type": "Sorcery",
                    "face": {
                        "front": {
                            "name": "Gitaxian Probe",
                            "type": "Sorcery",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/9/9/995486ce-58bb-4753-a812-0ca73ef1a235.jpg?1562880052"
                        }
                    },
                    "Colors": [
                        "U"
                    ],
                    "Color identity": [
                        "U"
                    ],
                    "set": "nph",
                    "isHorizontal": false,
                    "cost": 1
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            },
            {
                "id": "346c7c4c-53bc-4587-b74a-9f4aee54678f",
                "position": {
                    "section": "NONE",
                    "index": -1,
                    "reversedIndex": -1
                },
                "hiddenTo": {},
                "isTapped": false,
                "isFlipped": false,
                "cardData": {
                    "id": "c733873e-77db-471f-8061-139db24f7e7c",
                    "name": "Cephalid Coliseum",
                    "type": "Land",
                    "Card type": "Land",
                    "face": {
                        "front": {
                            "name": "Cephalid Coliseum",
                            "type": "Land",
                            "cost": 0,
                            "isHorizontal": false,
                            "image": "https://cards.scryfall.io/normal/front/0/3/03b9c9ed-fb6f-4f8d-bb1d-7999dec4245c.jpg?1743207488"
                        }
                    },
                    "Colors": [],
                    "Color identity": [
                        "U"
                    ],
                    "set": "tdc",
                    "isHorizontal": false
                },
                "counters": [
                    {},
                    {}
                ],
                "notes": "",
                "owner": "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6",
                "isHorizontal": false
            }
        ],
        "deckTopCardHiddenTo": {
            "fed75268-c816-48fd-8eb4-d5a87396332e": true,
            "ef32f23f-a797-435e-94a5-58e371317c64": true,
            "faa9bafc-3ce4-49e1-b19c-72054e5ff63b": true,
            "b8c0d8f7-fd6c-4b95-a565-47ddcd9d30c6": true
        },
        "cardsLinks": [],
        "profileData": {
            "name": "PiouPiou",
            "avatar": "https://i.imgur.com/7QmYdYk.jpeg",
            "background": "https://i.imgur.com/G8ceHWa.jpeg"
        },
        "playerCounters": [
            {
                "id": "d5fe5d40-9974-428b-9f2b-d54d8ea98c03",
                "value": 40
            },
            {
                "id": "ad7844d1-e550-40a2-bbb0-4b0f26b9f646",
                "value": 0
            }
        ],
        "playerTokens": {},
        "playerNotes": "Player1: 0\nPlayer2: 0\nPlayer3: 0",
        "refreshCount": 4
    }
}